(function($) {

function lightbox($el) {
  this.$el = $el;

  this.init();
}

lightbox.prototype = {

  classes: {
    item: '.js-lightbox-item',
  },

  init: function(){ 
    this.initLightbox();
  },

  initLightbox: function(){
    var self = this;
    $(self.classes.item).featherlightGallery({
      galleryFadeIn: app.settings.duration,        
      galleryFadeOut: app.settings.duration,   
      previousIcon: '<span class="lightbox__arrow  lightbox__arrow--left  icon--arrow-left">',
      nextIcon: '<span class="lightbox__arrow  lightbox__arrow--right  icon--arrow-right">',
    });
  },

};

var app = new function() {

  this.objects = {};

  this.settings = {
    easing: 'easeOutQuart',
    easingIn: 'easeInQuart',
    easingOut: 'easeOutQuart',
    easingInOut: 'easeInOutQuart',
    duration: 300,
  };

  this.names = {
    isActive: 'is-active',
    isOpen: 'is-open',
    isNew: 'is-new',
    isDisabled: 'is-disabled',
    isHidden: 'is-hidden',
    isDefault: 'is-default',
    isLoading: 'is-loading',
    isHover: 'is-hover',
  };

  this.vars = {
    pageInitialized: false,
    parameters: [],
    states: undefined,
    browser: undefined,
    browserVersion: undefined,
  };

  this.init = function() {
    var self = this;
    this.getParameters();
    
    Gridle.on('update', function(updatedStates, activeStates, inactiveStates) {
      if (!self.vars.pageInitialized) {
        self.vars.pageInitialized = true;
        app.objects.initModules = new initModules($('body'));
      }
      self.vars.states = Gridle.getActiveStatesNames();
    });
  };

  this.getParameters = function() {
    var self = this;
    var $container = $('#js-parameters');
    var $inputs = $container.find('input');
    $inputs.each(function() {
      self.vars.parameters[ $(this).attr('name') ] = $(this).val();
    });
  };

  this.debounce = function(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

}();

$.extend($.lazyLoadXT, {
  edgeY: 500,
  visibleOnly: false,
});

$(function() {
  app.init();
});



function gridleJs() {
  this.init();
}

gridleJs.prototype = {
  constructor: gridleJs,

  init: function() {
   Gridle.init({
    // make gridle output some console.log
    debug: false,

    // callback when the states changes
    onUpdate: function(updatedStates, activeStates, inactiveStates) {
        // do something here...
      },

    });
 },

};

function header($el) {
  this.$el = $el;

  this.$topLinks = $el.find(this.classes.topLinks);
  this.$topLink = $el.find(this.classes.topLink);
  this.$sub = $el.find(this.classes.sub);
  this.$subContainer = $el.find(this.classes.subContainer);
  this.$subLink = $el.find(this.classes.subLink);
  this.$subCategory = $el.find(this.classes.subCategory);
  this.$navicon = $el.find(this.classes.navicon);

  // vars
  this.currentSection = undefined;
  this.mouseOverArea = false;
  this.subMenuAnimated = false;
  this.menuOpen = false;
  this.windowScrollTimeout = undefined;
  this.oldScrollPos = 0;
  this.headerFixed = false;
  this.headerUnFixed = false;
  this.disableScrollCheck = false;
  this.headerHeight = $el.outerHeight();

  this.init();
}

header.prototype = {
  constructor: header,

  settings: {
    hoverTimeout: 0.2, // s
    submenuMovement: '-20px',
    submenuDuration: app.settings.duration * 1,
  },

  classes: {
    topLinks: '.js-header-top-links',
    topLink: '.js-header-top-link',
    sub: '.js-header-sub',
    subContainer: '.js-header-sub-container',
    subLink: '.js-header-sub-link',
    navicon: '.js-header-navicon',
    subCategory: '.js-header-sub-category',
  },

  names: {
    isFixedHeader: 'is-fixed-header',
    notFixedHeader: 'not-fixed-header',
  },

  init: function() {
    this.addListeners();
  },

  addListeners: function() {
    this.$topLink.on('mouseenter', {self: this}, this.topLinkMouseEnterHandler);
    
    this.$topLinks.on('mouseenter', {self: this}, this.topLinksMouseEnterHandler);
    this.$topLinks.on('mouseleave', {self: this}, this.topLinksMouseLeaveHandler);
    
    this.$sub.on('mouseenter', {self: this}, this.subMouseEnterHandler);
    this.$sub.on('mouseleave', {self: this}, this.subMouseLeaveHandler);

    this.$subLink.on('click', {self: this}, this.subLinkClickHandler);
    this.$navicon.on('click', {self: this}, this.naviconClickHandler);
    this.$subCategory.on('click', {self: this}, this.subCategoryClickHandler);
    $(document).on('click', {self: this}, this.documentClickHandler);

    $(window).on('scroll', {self: this}, this.windowScrollHandler);

  },

  documentClickHandler: function(event) {
    var self = event.data.self;
    if (!Gridle.isActive('lg') && self.menuOpen) {
      if (!$(event.target).closest(self.classes.sub).length) {
        self.closeSubmenu();
      }
    }
  },

  windowScrollHandler: function(event) {
    var self = event.data.self;

    if (!Gridle.isActive('lg')) return;
    if (self.disableScrollCheck) return;

    if (self.windowScrollTimeout !== undefined) {
      clearTimeout(self.windowScrollTimeout);
    }

    self.windowScrollTimeout = setTimeout(function() {

      var newScrollPos = $(window).scrollTop();

      if (newScrollPos == 0) {
        if (self.oldScrollPos == 0) {
          if (self.headerUnFixed) {
            $('body').addClass(self.names.isFixedHeader);
            $('body').removeClass(self.names.notFixedHeader);
            self.headerFixed = true;
            self.headerUnFixed = false;
          } else {
            $('body').removeClass(self.names.isFixedHeader);
            $('body').removeClass(self.names.notFixedHeader);
            self.headerFixed = false;
            self.headerUnFixed = false;
          }
        } else {
          $('body').removeClass(self.names.isFixedHeader);
          $('body').removeClass(self.names.notFixedHeader);
          self.headerFixed = false;
          self.headerUnFixed = false;
        }

        return;
      }

      if (newScrollPos - self.oldScrollPos < -10) {
        if (!self.headerFixed) {
          $('body').addClass(self.names.isFixedHeader);
          $('body').removeClass(self.names.notFixedHeader);
          self.headerFixed = true;
          self.headerUnFixed = false;
        }
      } else if (newScrollPos - self.oldScrollPos > 10) {
        self.unfixHeader();
      }
      self.oldScrollPos = newScrollPos;

      self.windowScrollTimeout = undefined;
    }, 50);

  },

  unfixHeader: function() {
    var self = this;
    if (self.headerFixed) {
      $('body').removeClass(self.names.isFixedHeader);
      $('body').addClass(self.names.notFixedHeader);
      self.headerFixed = false;
      self.headerUnFixed = true;
    }
  },

  topLinkMouseEnterHandler: function(event) {
    var self = event.data.self;
    var section = $(this).data('section');
    self.openSubmenu(section);
  },

  topLinksMouseEnterHandler: function(event) {
    var self = event.data.self;
    self.mouseOverArea = true;
  },

  topLinksMouseLeaveHandler: function(event) {
    var self = event.data.self;
    self.mouseOverArea = false;
    self.closeSubmenu(true);
  },

  subMouseEnterHandler: function(event) {
    var self = event.data.self;
    self.mouseOverArea = true;
  },

  subMouseLeaveHandler: function(event) {
    var self = event.data.self;
    self.mouseOverArea = false;
    self.closeSubmenu(true);
  },

  subLinkClickHandler: function(event) {
    var self = event.data.self;
    self.mouseOverArea = false;
    self.closeSubmenu(false);
  },

  naviconClickHandler: function(event) {
    var self = event.data.self;
    if (!self.menuOpen) {
      self.openSubmenu('none');
    } else {
      self.closeSubmenu();
    }

  },

  subCategoryClickHandler: function(event) {
    var self = event.data.self;
    var section = $(this).data('section');
    if (self.currentSection == section) {
      self.hideCurrentSection();
    } else {
      self.showSection(section);
    }
  },

  openSubmenu: function(section) { 
    var self = this;

    if (self.currentSection === undefined) {
      setTimeout(function() {
        if ((self.mouseOverArea && Gridle.isActive('lg')) || !Gridle.isActive('lg')) {
          if (!self.subMenuAnimated) {
            self.subMenuAnimated = true;
            $.Velocity.hook(self.$sub, 'translateY', self.settings.submenuMovement);
            if (section != 'none') {
              self.showSection(section);
            }
            self.$sub.velocity({
              opacity: 1,
              translateY: 0,
            }, {
              easing: app.settings.easing,
              duration: self.settings.submenuDuration,
              display: 'block', 
              queue: false,
              complete: function() { 
                self.subMenuAnimated = false;
              },
            }); 
            self.menuOpen = true;
            self.markNavicon();
          } else {
            self.openSubmenu(section);
          }
        }
      }, self.settings.hoverTimeout * 1000);
    } else if (self.currentSection === section) {
      return false;
    } else {
      var $oldSection = self.$subContainer.filter('[data-section="' + self.currentSection + '"]');
      $oldSection.hide();
      self.showSection(section);
    }

  },

  closeSubmenu: function(timeout) {
    var self = this;

    var timeoutDuration;
    if (timeout) {
      timeoutDuration = self.settings.hoverTimeout * 1000;
    } else {
      timeoutDuration = 0;
    }

    setTimeout(function() {
      if ((!self.mouseOverArea && Gridle.isActive('lg')) || !Gridle.isActive('lg')) {
        self.markTopLink();
        self.menuOpen = false;
        self.markNavicon();
        self.subMenuAnimated = true;
        self.$sub.velocity({
          opacity: 0,
          translateY: self.settings.submenuMovement,
        }, {
          easing: app.settings.easing,
          duration: self.settings.submenuDuration,
          display: 'none',
          queue: false,
          complete: function() {
            self.hideCurrentSection();
            self.subMenuAnimated = false;

          },
        });
      }  
    }, timeoutDuration);

  },

  showSection: function(section) {
    var self = this;
    self.currentSection = section;
    var $previousSection = self.$subContainer.filter('.' + app.names.isActive);
    var $newSection = self.$subContainer.filter('[data-section="' + section + '"]');

    if (Gridle.isActive('lg')) {
      $previousSection.removeClass(app.names.isActive).hide();
      $newSection.addClass(app.names.isActive).show();
    } else {
      var $currentCategoryButton = $newSection.prev(self.classes.subCategory);
      $previousSection.removeClass(app.names.isActive).velocity('slideUp', {
        easing: app.settings.easingInOut,
        duration: app.settings.duration * 2,
      });
      $newSection.addClass(app.names.isActive).velocity('slideDown', {
        easing: app.settings.easingInOut,
        duration: app.settings.duration * 2,
      });
    }
    self.markSubCategory(section);
    self.markTopLink(section);
  },

  hideCurrentSection: function() {
    var self = this;
    var $currentSection = self.$subContainer.filter('[data-section="' + self.currentSection + '"]');
    if (Gridle.isActive('lg')) {
      $currentSection.removeClass(app.names.isActive).hide();

    } else {
      var $currentCategoryButton = $currentSection.prev(self.classes.subCategory);
      $currentSection.removeClass(app.names.isActive).velocity('slideUp', {
        easing: app.settings.easingInOut,
        duration: app.settings.duration * 2,
      });
    }
    self.currentSection = undefined;
    self.markSubCategory('none');
  },

  markTopLink: function(section) {
    var self = this;

    var $previousLink = self.$topLink.filter('.' + app.names.isActive);
    $previousLink.removeClass(app.names.isActive);

    var $newLink = self.$topLink.filter('[data-section="' + section + '"]');
    $newLink.addClass(app.names.isActive);

  },

  markSubCategory: function(section) {
    var self = this;
    var $previousLink = self.$subCategory.filter('.' + app.names.isActive);
    $previousLink.removeClass(app.names.isActive);

    if (section != 'none') {
      var $newLink = self.$subCategory.filter('[data-section="' + section + '"]');
      $newLink.addClass(app.names.isActive);
    }

  },

  markNavicon: function() {
    var self = this;
    if (self.menuOpen) {
      self.$navicon.addClass(app.names.isActive);
    } else {
      self.$navicon.removeClass(app.names.isActive);
    }
  },

};

function carousel($el) {
  this.$el = $el;

  this.$dataItem = $el.find(this.classes.dataItem);
  this.$picture = $el.find(this.classes.picture);
  this.$title = $el.find(this.classes.title);
  this.$text = $el.find(this.classes.text);
  this.$link = $el.find(this.classes.link);
  this.$nextButton = $el.find(this.classes.nextButton);
  this.$picturePreload = $el.find(this.classes.picturePreload);
  this.$info = $el.find(this.classes.info);
  this.$index = $el.find(this.classes.index);
  this.$dynamicBg = $el.find(this.classes.dynamicBg);
  this.$line = $el.find(this.classes.line);
  this.$dot = $el.find(this.classes.dot);

  // vars
  this.carouselData = [];
  this.currentSlide = 0;
  this.slideCount = undefined;
  this.animating = false;
  this.automaticInterval = undefined;

  this.init();
}

carousel.prototype = {
  constructor: carousel,

  settings: {
    duration: app.settings.duration * 6,
    pictureMovement: '0px',
    infoMovement: '30px',
    pictureScale: 1.15,
    slideInterval: 7, // s
    pictureEasing: app.settings.easingInOut,
  },

  classes: {
    dataItem: '.js-carousel-data-item',
    picture: '.js-carousel-picture',
    title: '.js-carousel-title',
    text: '.js-carousel-text',
    link: '.js-carousel-link',
    nextButton: '.js-carousel-next',
    picturePreload: '.js-carousel-picture-preload',
    info: '.js-carousel-info',
    index: '.js-carousel-index',
    dynamicBg: '.js-carousel-dynamic-bg',
    line: '.js-carousel-line',
    dot: '.js-carousel-dot',
  },

  names: {
    isCloned: 'is-cloned',
  },

  init: function() {
    this.getData();
    this.launchAutomaticMode();
    this.addListeners();
  },

  getData: function() {
    var self = this;
    this.$dataItem.each(function(index) {
      var data = $(this).data();
      self.carouselData[index] = data;
    });
    self.slideCount = self.carouselData.length;
  },

  launchAutomaticMode: function() {
    var self = this;

    self.automaticInterval = setInterval(function() {
      self.showSlide('next');
    }, self.settings.slideInterval * 1000);
  },

  addListeners: function() {
    this.$nextButton.on('click', {self: this}, this.nextButtonClickHandler);
    this.$dot.on('click', {self: this}, this.dotClickHandler);

    this.$el.on('swipeleft', {self: this}, this.elSwipeLeftHandler);
    this.$el.on('swiperight', {self: this}, this.elSwipeRightHandler);
  },

  nextButtonClickHandler: function(event) {
    var self = event.data.self;
    self.showSlide('next');
    self.stopAutomaticMode();
  },

  dotClickHandler: function(event) {
    var self = event.data.self;
    var index = $(this).index();
    if (index == self.currentSlide) return false;
    self.showSlide('custom', index);
    self.stopAutomaticMode();
  },

  elSwipeLeftHandler: function(event) {
    var self = event.data.self;
    self.showSlide('next');
    self.stopAutomaticMode();
  },
  elSwipeRightHandler: function(event) {
    var self = event.data.self;
    self.showSlide('prev');
    self.stopAutomaticMode();
  },

  showSlide: function(mode, index) {
    var self = this;
    var newSlideId, pictureMovement;

    if (!self.animating) {

      self.animating = true;

      if (mode == 'next') {
        newSlideId = self.currentSlide + 1;
        if (newSlideId == self.slideCount) {
          newSlideId = 0;
        }
      } else if (mode == 'prev') {
        newSlideId = self.currentSlide - 1;
        if (newSlideId == -1) {
          newSlideId = self.slideCount - 1;
        }
      } else if (mode == 'custom') {
        newSlideId = index;
      }
      nextSlideId = newSlideId + 1;
      if (nextSlideId == self.slideCount) {
        nextSlideId = 0;
      }

      // settings
      if (mode == 'next' || mode == 'custom') {
        pictureMovement = self.settings.pictureMovement;
        infoMovement = self.settings.infoMovement;
        pictureTransformOrigin = 'center center';
      } else if (mode == 'prev') {
        pictureMovement = '-' + self.settings.pictureMovement;
        infoMovement = '-' + self.settings.infoMovement;
        pictureTransformOrigin = 'center center';
      }

      // picture
      var $newPicture = self.$picture.clone();
      $newPicture.addClass(self.names.isCloned);
      $newPicture.css('background-image', 'url(' + self.carouselData[newSlideId]['picture'] + ')');
      self.$picture.after($newPicture);


      // $.Velocity.hook($newPicture, "translateX", pictureMovement);
      $.Velocity.hook($newPicture, 'scaleX', self.settings.pictureScale);
      $.Velocity.hook($newPicture, 'scaleY', self.settings.pictureScale);
      // $newPicture.css('transform-origin', pictureTransformOrigin);
      $newPicture.velocity({
        // translateX: 0,
        scaleX: 1,
        scaleY: 1,
        opacity: 1,
      }, {
        easing: self.settings.pictureEasing,
        duration: self.settings.duration,
        display: 'block',
        complete: function() {
          self.animating = false;
          self.$picture.remove();
          self.$picture = $newPicture;
          $newPicture.removeClass(self.names.isCloned);
        },
      });

      self.$picturePreload.attr('src', self.carouselData[nextSlideId]['picture']);


      // info

      self.$info.velocity({
        opacity: 0,  
      }, {
        duration: self.settings.duration * 0.6,
        complete: function() {
          self.$title.text(self.carouselData[newSlideId]['title']);
          self.$text.text(self.carouselData[newSlideId]['text']);
          self.$link.attr('href', self.carouselData[newSlideId]['link']);

          $.Velocity.hook(self.$info, 'translateX', '-' + infoMovement);
          self.$info.velocity({
            opacity: 1,  
            translateX: '0px', 
          }, {
            duration: self.settings.duration * 0.8,
            easing: app.settings.easingOut,
          });
        },
      });

      // dynamicBg 
      self.$dynamicBg.css('background-color', self.carouselData[newSlideId]['color']);


      self.currentSlide = newSlideId;
      self.markNavs();

    }
  },

  stopAutomaticMode: function() {
    var self = this;
    clearInterval(self.automaticInterval);
  },

  markNavs: function() {
    var self = this;
    var index = self.currentSlide + 1;
    self.$index.text(index);

    self.$dot.filter('.' + app.names.isActive).removeClass(app.names.isActive);
    self.$dot.eq(self.currentSlide).addClass(app.names.isActive);

  },


};

function gallery($el) {
  this.$el = $el;

  this.owl = undefined;
  this.settings = {};
  var data = this.$el.data();

  ( data['galleryCenter'] !== undefined ) ? this.settings.center = data['galleryCenter'] : this.settings.center = this.defaults.center;

  // init
  this.init();
}

gallery.prototype = {
  constructor: gallery,

  classes:{
    item: '.owl-item',
  },

  defaults:{
    center: true,
  },

  init: function(){
    this.initOwlCarousel();
    this.addListeners();
  },

  addListeners: function(){
    this.$el.on('click', this.classes.item, {self: this}, this.itemClickHandler);
  },

  itemClickHandler: function(event){
    var self = event.data.self;
    event.preventDefault();
    var index = $(this).index();
    self.owl.trigger('to.owl.carousel', index);
  },

  initOwlCarousel: function(){
    var self = this;
    console.log(self.$el);

    self.$el.waitForImages(function() {
      self.owl = self.$el.owlCarousel({
        dots: true,
        loop: false,
        center: self.settings.center,
        // items: 1,
        smartSpeed: app.settings.duration*2,
        // autoWidth: true,
        nav: false,
        margin: 24,
        autoPlay: false,
        // responsive: self.settings.responsive,
      });
    });



  },

};

function products($el) {
  this.$el = $el;

  this.$filters = $el.find(this.classes.filters);
  this.$filtersContent = $el.find(this.classes.filtersContent);
  this.$filtersOpen = $el.find(this.classes.filtersOpen);
  this.$filtersReset = $el.find(this.classes.filtersReset);
  this.$filtersForm = this.$filters.find('form');
  this.$grid = $el.find(this.classes.grid);
  this.$gridContent = $el.find(this.classes.gridContent);
  this.$filtersColumn = $el.find(this.classes.filtersColumn);
  this.$filtersHeaderContent = $el.find(this.classes.filtersHeaderContent);
  this.$box = $el.find(this.classes.box);


  // vars
  this.filtersOpened = false;
  this.ajaxCall = undefined;
  this.categoryId = $el.data('category');

  this.filterDelay = false;

  this.init();
}

products.prototype = {
  constructor: products,

  classes: {
    filters: '.js-products-filters',
    filtersContent: '.js-products-filters-content',
    filtersOpen: '.js-products-filters-open',
    filtersReset: '.js-products-filters-reset',
    filtersColumn: '.js-products-filters-column',
    filtersHeaderContent: '.js-products-filters-header-content',
    grid: '.js-products-grid',
    gridContent: '.js-products-grid-content',
    box: '.js-products-filters-box',
  },

  names: {
  },

  init: function() {
    this.addListeners();
    this.checkForHash();
    if (!document.documentElement.classList.contains('theme-tetesept')) {
      this.loadProducts();
    }
  },

  checkForHash: function() {
    var self = this;

    if (window.location.hash.indexOf('filter=') != -1) {
      var ids = window.location.hash.replace('#filter=', '').split(',');

      ids.map(function(item) {
        if (item) {
          var input = $('input#' + item);
          if (input.length) {
            input.click();
          }
        }
      });
    }
  },

  addListeners: function() {
    this.$filtersHeaderContent.on('mouseover', {self: this}, this.filtersHeaderContentMouseOverHandler);
    this.$filtersHeaderContent.on('mouseleave', {self: this}, this.filtersHeaderContentMouseLeaveHandler);
    this.$filtersOpen.on('click', {self: this}, this.filtersOpenClickHandler);
    this.$filtersReset.on('click', {self: this}, this.filtersResetClickHandler);
    this.$filtersColumn.on('click', 'input[type="checkbox"]', {self: this}, this.checkboxClickHandler);
    $(document).on('reloadproducts', {self: this}, this.loadProductsNewFilter);
  },

  filtersOpenClickHandler: function(event) {
    var self = event.data.self;
    var $column = $(this).siblings(self.classes.column);
    self.filtersOpen($column);
  },

  filtersResetClickHandler: function(event) {
    var self = event.data.self;
    self.filtersReset();
    self.filtersClose();
  },

  filtersHeaderContentMouseOverHandler: function(event) {
    var self = event.data.self;
    if (!self.filtersOpened) {
      self.filtersOpen();
    }
  },

  filtersHeaderContentMouseLeaveHandler: function(event) {
    var self = event.data.self;
    if (self.filtersOpened) {
      self.filtersClose();
    }
  },

  checkboxClickHandler: function(event) {
    var self = event.data.self;
    var $filtersColumn = $(this).closest(self.classes.filtersColumn);
    var $default = $filtersColumn.find('input[type="checkbox"].all');
    var $openButton = $filtersColumn.siblings(self.classes.filtersOpen);

    var singleFilter = false;

    if ($('html').hasClass('theme-burgit') || $('html').hasClass('theme-depilan')) {
      singleFilter = true;
    }

    if (singleFilter) {
      var $allInputs = $filtersColumn.find('input[type="checkbox"]:checked')
      var thisName = $(this).attr('name');

      $allInputs.each(function() {
        var name = $(this).attr('name')
        if (thisName !== name) {
          $(this).prop('checked', false)
        }
      })
    }

    if (!$(this).hasClass('all')) {
      $default.prop('checked', false);
      $openButton.addClass(app.names.isActive);
    } else {
      var $checked = $filtersColumn.find('input[type="checkbox"]:checked');
      $checked.prop('checked', false);
      $default.prop('checked', true);
      $openButton.removeClass(app.names.isActive);
    }

    var $checked = $filtersColumn.find('input[type="checkbox"]:checked');

    if (!$checked.length) {
      $default.prop('checked', true);
    }

    self.loadProducts($(this));
  },

  filtersOpen: function($column) {
    var self = this;

    if (Gridle.isActive('lg') || !$column) {
      $column = self.$filtersColumn;
    }

    var $box = $column.closest(self.classes.box);
    if (!$box.hasClass(app.names.isOpen)) {

      $box.addClass(app.names.isOpen);
      $column.velocity('slideDown', {
        easing: app.settings.easingInOut,
        duration: app.settings.duration * 2,
        complete: function() {
          self.filtersOpened = true;
        },
      });
      self.$filtersContent.velocity('slideDown', {
        easing: app.settings.easingIn,
        duration: app.settings.duration * 2,
      });
    }

  },

  filtersClose: function() {
    var self = this;

    self.$box.removeClass(app.names.isOpen);
    self.$filtersContent.velocity('slideUp', {
      duration: app.settings.duration * 2,
      complete: function() {
        self.filtersOpened = false;
      },
    });
    self.$filtersColumn.velocity('slideUp', {
      easing: app.settings.easingInOut,
      duration: app.settings.duration * 2,
    });

  },

  filtersReset: function() {
    var self = this;

    var $checked = self.$filtersColumn.find('input[type="checkbox"]:checked');
    var $default = self.$filtersColumn.find('input[type="checkbox"]:default');
    self.$filtersOpen.removeClass(app.names.isActive);
    $checked.prop('checked', false);
    setTimeout(function() {
      $default.prop('checked', true);
      self.loadProducts();
    }, 10);


  },

  loadProducts: function($checkbox) {
    var self = this;


    clearTimeout(self.filterDelay)
    self.filterDelay = setTimeout(function() {
      var formData = self.$filtersForm.serialize();

      app.objects.preloader.showPreloader(self.$grid);
      if ($checkbox) {
        app.objects.preloader.showPreloader($checkbox.next('label'), '', 'small', 'secondary');
      }

      self.$gridContent.velocity({
        opacity: 0.5,
      }, {
        duration: app.settings.duration,
      });

      if (self.ajaxCall != undefined) {
        self.ajaxCall.abort();
      }

      // hash the formData
      var split = [];
      if (formData.length > 0) {
        split = formData.split('&');
      }

      var newHash = '';
      split.map(function(item) {
        var id = item.split('=')[0];
        newHash += id + ',';
      });

      if (newHash.length) {
        window.location.hash = 'filter=' + newHash.slice(0,-1);
      } else {
        window.location.hash = '';
      }

      self.ajaxCall = $.ajax({
        url: app.vars.parameters['product-overview-url'],
        method: 'POST',
        data: {
          formData: formData,
          categoryId: self.categoryId
        },
      })
      .done(function(response) {

        response = $.parseJSON(response);
        var message = response['message'];
        if (response['status'] == 'success') {
          self.$gridContent.html(response['html']);
          app.objects.initModules.initLocal(self.$gridContent);
          self.$gridContent.waitForImages(function() {
            $(document).trigger('load');
            $(window).trigger('resize');
            // $.fn.matchHeight._update();
            setTimeout(function() {
              // $.fn.matchHeight._update();
              $(document).trigger('load');
              $(window).trigger('resize');
            }, 300);
          });
        } else {

        }
        self.$gridContent.velocity({
          opacity: 1,
        }, {
          duration: app.settings.duration,
        });
        app.objects.preloader.hidePreloader(self.$grid);
        app.objects.preloader.hidePreloader(self.$filtersColumn.find('input[type="checkbox"]').next('label'));

        self.ajaxCall = undefined;
      });
    }, 400)

  },

  loadProductsNewFilter: function(event, data) {
    var self = event.data.self;
    console.log(event)

    console.log('load products', data)
    


    clearTimeout(self.filterDelay)
    self.filterDelay = setTimeout(function() {
      var formData = data.join('&');

      app.objects.preloader.showPreloader(self.$grid);

      self.$gridContent.velocity({
        opacity: 0.5,
      }, {
        duration: app.settings.duration,
      });

      if (self.ajaxCall != undefined) {
        self.ajaxCall.abort();
      }

      // hash the formData
      var split = [];
      if (formData.length > 0) {
        split = formData.split('&');
      }

      var newHash = '';
      split.map(function(item) {
        var id = item.split('=')[0];
        newHash += id + ',';
      });

      if (newHash.length) {
        window.location.hash = 'filter=' + newHash.slice(0,-1);
      } else {
        window.location.hash = '';
      }


      self.ajaxCall = $.ajax({
        url: app.vars.parameters['product-overview-url'],
        method: 'POST',
        data: {
          formData: formData,
          categoryId: self.categoryId
        },
      })
      .done(function(response) {

        response = $.parseJSON(response);
        var message = response['message'];
        if (response['status'] == 'success') {
          self.$gridContent.html(response['html']);
          app.objects.initModules.initLocal(self.$gridContent);
          self.$gridContent.waitForImages(function() {
            $(document).trigger('load');
            $(window).trigger('resize');
            // $.fn.matchHeight._update();
            setTimeout(function() {
              // $.fn.matchHeight._update();
              $(document).trigger('load');
              $(window).trigger('resize');
            }, 300);
          });
        } else {

        }
        self.$gridContent.velocity({
          opacity: 1,
        }, {
          duration: app.settings.duration,
        });
        app.objects.preloader.hidePreloader(self.$grid);
        app.objects.preloader.hidePreloader(self.$filtersColumn.find('input[type="checkbox"]').next('label'));

        self.ajaxCall = undefined;
      });
    }, 400)

  },

};

function preloader() {}

preloader.prototype = {

  states: {
    hasPreloader: 'has-preloader',
  },

  showPreloader: function($element, position, type, color){
    var self = this;

    if($element.children('.preloader').length) return false;

    $element.addClass(self.states.hasPreloader);

    var typeClass = (type ? 'preloader--' + type : '');
    var colorClass = (color ? 'preloader--' + color : '');


    var $preloader = $('<div class="preloader  '+ typeClass +'  '+ colorClass +'"><div class="preloader__inner"></div></div>');
    if(position == 'prepend'){
     $element.prepend($preloader);
   } else {
     $element.append($preloader);
   }

 },

 hidePreloader: function($element){
  var self = this;
  var $preloader = $element.find('.preloader');
  $element.removeClass(self.states.hasPreloader);
  if($preloader.length){
    $preloader.addClass(app.names.isHidden);
    setTimeout(function() {
      $preloader.remove();
    }, app.settings.duration);
  }
}
};

function tabs($el) {
  this.$el = $el;

  this.$nav = this.$el.find(this.classes.nav);
  this.$navItem = this.$el.find(this.classes.navItem);
  this.$contentItem = this.$el.find(this.classes.contentItem);
  this.$content = this.$el.find(this.classes.content);
  this.$close = this.$el.find(this.classes.close);

  // vars
  this.currentItem = 0;

  // init
  this.init();
}

tabs.prototype = {
  constructor: tabs,

  settings: {
    tabContentMovement: '20px',
  },

  classes: {
    nav: '.js-tabs-nav',
    navItem: '.js-tabs-nav-item',
    content: '.js-tabs-content',
    contentItem: '.js-tabs-content-item',
    close: '.js-tabs-close',
  },

  names: {
    isUsed: 'is-used',
  }, 

  init: function(){
    this.initialSetup();
    this.addListener();
  },

  initialSetup: function(){
    var self = this;
    var $contentItem = self.$contentItem.filter('[data-tab="'+ self.currentItem +'"]');
    self.$content.css('height', $contentItem.outerHeight());
  },

  addListener: function(){
    this.$navItem.on('click', {self: this}, this.navItemClickHandler);
    this.$close.on('click', {self: this}, this.closeClickHandler);
  },

  navItemClickHandler: function(event){
    var self = event.data.self;
    var $navItem = $(this);
    var tabId = parseInt($navItem.data('tab'));
    if(tabId != self.currentItem){
      self.openTab(tabId);
    }
  }, 

  closeClickHandler: function(event){
    var self = event.data.self;
    self.closeTab();
  },

  openTab: function(tabId){
    var self = this;

    var $navItem = self.$navItem.filter('[data-tab="'+ tabId +'"]');
    var $contentItem = self.$contentItem.filter('[data-tab="'+ tabId +'"]');

    var previousContentMovement = '-' + self.settings.tabContentMovement;
    var currentContentMovement = self.settings.tabContentMovement;
    if(tabId < self.currentItem){
      previousContentMovement = self.settings.tabContentMovement;
      currentContentMovement = '-' + self.settings.tabContentMovement;
    }

    var $previousContentItem = self.$contentItem.filter('[data-tab="'+ self.currentItem +'"]');
    $previousContentItem.velocity({
      opacity: 0,  
      translateX: previousContentMovement,
    },{
      duration: app.settings.duration,
      display: 'none',
      complete: function(){
        $.Velocity.hook($contentItem, "translateX", currentContentMovement);
        $contentItem.velocity({
          opacity: 1,
          translateX: 0,
        },{
          easing: app.settings.easing,
          duration: app.settings.duration*2,
          display: 'block',
        });

        setTimeout(function() {
            self.$content.css('height', $contentItem.outerHeight());
          }, 50);
      }
    });

    self.$el.addClass(self.names.isUsed);

    self.$navItem.filter('.' + app.names.isActive).removeClass(app.names.isActive);
    $navItem.addClass(app.names.isActive);


    self.currentItem = tabId;
  },

  closeTab: function(){
    var self = this;
    if(!app.vars.biggerScreenState){
      self.$el.removeClass(self.names.isUsed);
      self.$el.css('height', self.$nav.outerHeight());
    }
  },

};

function presentation($el) {
  this.$el = $el;

  this.$container = $el.find(this.classes.container);
  this.$next = $el.find(this.classes.next);
  this.$prev = $el.find(this.classes.prev);
  this.$pItem = $el.find(this.classes.pItem);
  this.$item = $el.find(this.classes.item);

// vars
this.owl = undefined;
this.currentSlide = 0;
this.resizeTimeout = undefined;
this.itemCount = this.$pItem.length;
this.nextVisible = false;

// init
this.init();
}

presentation.prototype = {
  constructor: presentation,

  settings: {
    duration: app.settings.duration * 4,
    contentMovement: '50px',
  },

  classes: {
    container: '.js-presentation-container',
    prev: '.js-presentation-prev',
    next: '.js-presentation-next',
    pItem: '.js-presentation-item',
    item: '.owl-item',
  },

  names: {
    isDisabled: 'is-disabled',
  },

  init: function() {
    this.addListener();
    this.initialSetup();
  },

  addListener: function() {
    this.$container.on('click', this.classes.item, {self: this}, this.itemClickHandler);
    this.$prev.on('click', {self: this}, this.prevClickHandler);
    this.$next.on('click', {self: this}, this.nextClickHandler);
    $(window).on('resize', {self: this}, this.windowResizeHandler);
  },

  itemClickHandler: function(event) {
    var self = event.data.self;
    if ($(this).is('.' + self.names.isDisabled)) {
      event.preventDefault();
      var index = $(this).index();
      self.owl.trigger('to.owl.carousel', index);
    }
  },

  prevClickHandler: function(event) {
    var self = event.data.self;
    self.goToPrev();
  },

  nextClickHandler: function(event) {
    var self = event.data.self;
    self.goToNext();
  },

  windowResizeHandler: function(event) {
    var self = event.data.self;

    if (self.resizeTimeout !== undefined) {
      clearTimeout(self.resizeTimeout);
    }
    self.resizeTimeout = setTimeout(function() {
      self.owl.trigger('changed.owl.destroy');
      setTimeout(function() {
        self.initialSetup();
      }, 100);
    }, 500);
  },

  initialSetup: function() {
    var self = this;
    self.setContainerWidth();

    this.owl = this.$container.owlCarousel({
      dots: false,
      autoWidth: true,
    });

    self.getActiveCount();
    self.markDisabled();
    if (self.itemCount < 3) {
      self.$prev.hide();
      self.$next.hide();
    }

    self.owl.on('changed.owl.carousel', function(event) {
      setTimeout(function() {
      self.currentSlide = event.property.value;
        self.markDisabled();
      }, 10);

    });

  },

  markDisabled: function() {
    var self = this;
    var $activeItems = self.$container.find('.active');
    if (self.itemCount > 2) {
      if ($activeItems.length == self.activeCount) {
        var $lastActive = $activeItems.last();
        self.$container.find('.' + self.names.isDisabled).removeClass(self.names.isDisabled);
        $lastActive.addClass(self.names.isDisabled);
        $lastActive.next().addClass(self.names.isDisabled);
        self.showNextButton();
      } else {
        self.$container.find('.' + self.names.isDisabled).removeClass(self.names.isDisabled);
        self.hideNextButton();
      }
      if (self.currentSlide === 0) {
        self.$prev.hide();
      } else {
        self.$prev.show();
      }
    }
  },

  getActiveCount: function() {
    var self = this;
    self.activeCount = self.$container.find(self.classes.item + '.active').length;
  },

  setContainerWidth: function() {
    var self = this;
    var leftPos = parseInt(self.$container.parent().offset().left);
    var windowWidth = parseInt($(window).width());
    var containerWidth = windowWidth - leftPos;

    self.$container.width(containerWidth);
  },

  goToPrev: function() { 
    this.owl.trigger('prev.owl.carousel', [300]);
  },

  goToNext: function() { 
    this.owl.trigger('next.owl.carousel', [300]);
  },

  showNextButton: function() {
    if (!this.nextVisible) {
      this.$next.show();
      this.nextVisible = true;
    }
  },

  hideNextButton: function() {
    if (this.nextVisible) {
      this.$next.hide();
      this.nextVisible = false;
    }
  },


};

function faq($el) {
  this.$el = $el;

  this.$item = $el.find(this.classes.item);
  this.$header = $el.find(this.classes.header);
  this.$content = $el.find(this.classes.content);


  // vars
  this.init();
}

faq.prototype = {
  constructor: faq,

  settings: {
  },

  classes: {
    item: '.js-faq-item',
    header: '.js-faq-header',
    content: '.js-faq-content',
  },


  init: function(){
    this.addListeners();
  },

  addListeners: function(){
    this.$header.on('click', {self: this}, this.headerClickHandler);
  },

  headerClickHandler: function(event){
    var self = event.data.self;

    var $item = $(this).closest(self.classes.item);
    var $content = $item.find(self.classes.content);

    if($item.hasClass(app.names.isActive)){
      $item.removeClass(app.names.isActive);
      $content.velocity('slideUp',{
        easing: app.settings.easingInOut,
        duration: app.settings.duration*2,
      });
    } else {
      $item.addClass(app.names.isActive);
      $content.velocity('slideDown',{
        easing: app.settings.easingInOut,
        duration: app.settings.duration*2,
      });
    }


  },



};

function scrollNav($el) {
  this.$el = $el;

  this.$link = $el.find(this.classes.link);

  // vars
  this.sectionPositions = [];
  this.activeSection = undefined;
  this.navHeight = undefined;
  this.scrollTimeout = undefined;
  this.resizeTimeout = undefined;
  this.timelineId = $el.data('timelineId');

  // init
  this.init();
}

scrollNav.prototype = {
  constructor: scrollNav,

  classes: {
    link: '.js-scroll-nav-link',
  },

  init: function() {
    this.getSectionPositions();
    this.getNavHeight();
    this.scrollToInitialPosition();
    this.addListener();
  },

  getSectionPositions: function() {
    var self = this;
    self.sectionPositions = [];
    this.$link.each(function() {
      var href = $(this).attr('href');
      var $section = $(href);
      var sectionOffset = parseInt($section.offset().top, 10);
      if (!Gridle.isActive('lg')) {
        sectionOffset -= app.objects.header.headerHeight;
      }
      self.sectionPositions.push(sectionOffset);
    });
  },

  getNavHeight: function() {
    this.navHeight = this.$el.outerHeight();
  },

  scrollToInitialPosition: function() {
    var self = this;
    var location = window.location.href;
    var anchor = location.split('#')[1];
    if (anchor == undefined) {
      anchor = false;
      var state = History.getState();
      if (state != undefined) {
        anchor = state.data.anchor;
      }
    }

    if (anchor) {
      setTimeout(function() {
        self.scrollToElement('#' + anchor);
        if (anchor === self.timelineId && app.objects.timeline) {
          app.objects.timeline.showBox();
        }
      }, app.settings.duration * 3);
    }
  },

  addListener: function() {
    this.$link.on('click', {self: this}, this.linkClickHandler);
    $(window).on('scroll.scrollnav', {self: this}, this.windowScrollHandler);
    $(window).on('resize.scrollnav', {self: this}, this.windowResizeHandler);
  },

  linkClickHandler: function(event) {
    var self = event.data.self;
    var $link = $(this);
    event.preventDefault();
    var href = $(this).attr('href');
    self.scrollToElement(href, $link);
  },

  windowScrollHandler: function(event) {
    var self = event.data.self;

    if (self.scrollTimeout !== undefined) {
      clearTimeout(self.scrollTimeout);
    }
    self.scrollTimeout = setTimeout(function() {
      self.checkPagePosition();
    }, 100);
  },

  windowResizeHandler: function(event) {
    var self = event.data.self;

    if (self.resizeTimeout !== undefined) {
      clearTimeout(self.resizeTimeout);
    }
    self.resizeTimeout = setTimeout(function() {
      self.getSectionPositions();
      self.getNavHeight();
    }, 100);
  },

  scrollToElement: function(href, $link) {
    var self = this;
    var $target = $(href);

    $link = $link || '';
    if ($link == '') {
      $link = self.getLinkByHref(href);
    }

    var currentSectionIndex = self.getSectionIndex($link);
    self.markLink(currentSectionIndex);

    app.objects.scrollToElement.scroll($target);

  },

  checkPagePosition: function() {
    var self = this;

    if (app.objects.overlay.overlayOpenStarted) return false;

    var currentSectionIndex;
    var currentScrollPosition = $(document).scrollTop() + self.navHeight + 5;


    $.each(self.sectionPositions, function(index, value) {
      if (currentScrollPosition > value) {
        currentSectionIndex = index;
      }
    });
    self.markLink(currentSectionIndex);

  },

  markLink: function(currentSectionIndex) {
    var self = this;

    if (self.activeSection != currentSectionIndex) {
      self.activeSection = currentSectionIndex;
      self.$link.filter('.' + app.names.isActive).removeClass(app.names.isActive);
      self.$link.eq(self.activeSection).addClass(app.names.isActive);
      if (currentSectionIndex == undefined) {
        self.$link.eq(0).addClass(app.names.isDefault);
      } else {
        self.$link.eq(0).removeClass(app.names.isDefault);
      }
    }
  },

  getSectionIndex: function($element) {
    return this.$link.index($element[0]);
  },

  getLinkByHref: function(href) {
    return this.$link.filter('[href="' + href + '"]');
  },




};

function scrollToElement() {
  this.init();
}

scrollToElement.prototype = { 
  constructor: scrollToElement,

  classes: {
    link: '.js-scroll-to',
  },

  init: function() {
    this.addListeners();
  },

  addListeners: function() {
    $(document).on('click', this.classes.link, {self: this}, this.linkClickHandler);
  },

  linkClickHandler: function(event) {
    var self = event.data.self;
    event.preventDefault();
    var $target = $($(this).attr('href'));

    self.scroll($target);

  },

  scroll: function($target) {
    var offset = 0;

    app.objects.header.disableScrollCheck = true;
    app.objects.header.unfixHeader();

    if (!Gridle.isActive('lg')) {
      offset += -app.objects.header.headerHeight;
    }
    if (app.objects.scrollNav) {
      offset += -app.objects.scrollNav.navHeight + 1;
    }
    // if (app.objects.overview) {
    //   offset += -app.objects.overview.barHeight + 2;
    // }

    offset += 1;

    $target.velocity('scroll', {
      easing: app.settings.easingInOut,
      duration: app.settings.duration * 4,
      offset: offset,
      complete: function() {
        app.objects.header.disableScrollCheck = false;
        app.objects.header.oldScrollPos = 1;
      },
    });
  },

};

function overlay() {

  // elements
  this.$pageCanvas = $(this.ids.pageCanvas);
  this.$overlay = $(this.ids.overlay);
  this.$overlayContainer = $(this.ids.overlayContainer);
  this.$overlayPreloader = $(this.ids.overlayPreloader);
  this.$overlayBgPageContainer = $(this.ids.overlayBgPageContainer);

  // vars
  this.basePageUrl = app.objects.page.getBasePageUrl();
  this.overlayOpenStarted = false;
  this.overlayOpen = false;
  this.canvasOriginalPosition = 0;
  this.overlayFirst = false;


  this.init();
}

overlay.prototype = {
  constructor: overlay,

  settings: {
    duration: app.settings.duration * 1,
    distance: 50,
  },

  classes: {
    closeButton: '.js-overlay-close',
    overlayContent: '.js-overlay-content',
  },

  ids: {
    pageCanvas: '#page-canvas',
    overlay: '#overlay',
    overlayContainer: '#overlay-container',
    overlayPreloader: '#overlay-preloader',
    overlayBgPageContainer: '#overlay-bg-page',
  },

  names: {
    isStatic: 'is-static',
  },

  init: function() {
    this.addListeners();
    this.loadBgPage();
  },

  addListeners: function() {
    $('body').on('click', 'a[target="_top"]', {self: this}, this.linkClickHandler);
    $(document).on('click', this.classes.closeButton, {self: this}, this.closeClickHandler);
    $(window).on('statechange', {self: this}, this.stateChangeHandler);
    $(document).on('click', {self: this}, this.documentClickHandler);
  },


  ///////////
  // Handlers

  linkClickHandler: function(event) {
    if (!(app.vars.browser == 'explorer' && app.vars.browserVersion <= 9)) {
      event.preventDefault();
      var self = event.data.self;
      var $link = $(this);
      var url = $link.attr('href');
      self.goToOverlayUrl(url);
    }
  },

  closeClickHandler: function(event) {
    var self = event.data.self;
    self.goToBgPage();
  },

  stateChangeHandler: function(event) {
    var self = event.data.self;
    var currentState = History.getState();
    var url = currentState['url'];

    if (currentState.data.state == 'overlay') {
      self.openOverlay(url);
    } else if (currentState.data.state != 'overlay') { 
      if (self.overlayOpen) {
        self.closeOverlay(url);
      }
    }
  },

  documentClickHandler: function(event) {
    var self = event.data.self;
    if (self.overlayOpen) {
      if (
        !$(event.target).closest(self.classes.overlayContent).length && 
        !$(event.target).closest('[class^="featherlight-"]').length && 
        !$(event.target).filter('.featherlight').length
        ) {
        self.goToBgPage(); 
    }
  }
},  



  ///////
  // Main

  openOverlay: function(url) {
    var self = this;

    // fix canvas
    app.objects.header.disableScrollCheck = true;
    var canvasOffset = $('html').scrollTop();
    if (canvasOffset == 0) {
      canvasOffset = $('body').scrollTop();
    }

    if ($('body').hasClass('adminbar')) {
      canvasOffset = parseInt(canvasOffset) - parseInt($('html').css('margin-top'));
    }

    self.overlayOpenStarted = true;

    if (!this.overlayOpen) {
      this.$pageCanvas
      .css({
        'top': -canvasOffset,
        'position': 'fixed',
      });
      this.canvasOriginalPosition = canvasOffset;
    }

    // show preloader
    if (!this.overlayOpen) {
      this.$overlay.velocity('fadeIn', {
        duration: self.settings.duration,
        complete: function() {
          self.overlayOpen = true;
        },
      });
      self.overlayAjaxCall(url);
    } else {
      this.$overlayContainer.velocity('fadeOut', {
        duration: self.settings.duration,
        complete: function() {
          self.overlayAjaxCall(url);
        },
      });
      this.$overlayPreloader.velocity('fadeIn', {
        duration: self.settings.duration,
      });
    }

  },

  closeOverlay: function() {
    var self = this;
    this.overlayOpen = false;

    // fade out overlay
    this.$overlay.velocity('fadeOut', {
      duration: self.settings.duration,
      complete: function() {

        if (self.overlayFirst) {
          self.overlayFirst = false;
        }

        $.each(app.objects.sticky, function(index, element) {
          element.unfreezeStickyKit();
        });
        self.overlayOpenStarted = false;


        // unfix canvas
        if (!self.$pageCanvas.length) {
          self.$pageCanvas = $(self.ids.pageCanvas);
        }
        self.$pageCanvas.removeAttr('style');
        if ($('body').hasClass('adminbar')) {
          self.canvasOriginalPosition += parseInt($('html').css('margin-top'));
        }
        $('body, html').scrollTop(self.canvasOriginalPosition);
        setTimeout(function() {
          app.objects.header.disableScrollCheck = false;
        }, 100);

        $(this).removeClass(self.names.isStatic);

        // reset overlay
        self.$overlayPreloader.show().css('opacity', 1);
        self.$overlayContainer.hide();
      },
    });

  },

  overlayAjaxCall: function(url) {
    var self = this;

    var overlayPageCall = $.ajax({
      url: url,
      method: 'POST',
      data: {'ajaxCall': true},
    })
    .done(function(msg) {
      self.overlayContentLoaded(msg);
    });
  },

  overlayContentLoaded: function(msg) {
    var self = this;
    this.$overlayPreloader.velocity('fadeOut', {
      duration: self.settings.duration,
    });

    this.$overlayContainer.html(msg);
    $.Velocity.hook(this.$overlayContainer, 'translateY', self.settings.distance + 'px'); 
    this.$overlayContainer.velocity({
      opacity: 1,
      translateY: 0,
    }, {
      display: 'block',
      duration: self.settings.duration,
      easing: app.settings.easing,
    });

    $.each(app.objects.sticky, function(index, element) {
      element.freezeStickyKit();
    });

    setTimeout(function() {
      $(document).trigger('load');
    }, 100);

    app.objects.track.trackPage();

    app.objects.initModules.initLocal(this.$overlayContainer);
  },


  loadBgPage: function() {
    var self = this;

    if (!this.$overlayBgPageContainer.length) {
      return false;
    }

    self.overlayFirst = true;

    var url = this.$overlayBgPageContainer.data('url');
    this.basePageUrl = url;
    self.overlayOpen = true;

    var overlayPageBgCall = $.ajax({
      url: url,
      method: 'POST',
      data: {'ajaxBgCall': true},
    })
    .done(function(msg) {
      self.$overlayBgPageContainer.html(msg);
      app.objects.initModules.initLocal(self.$overlayBgPageContainer);
      app.objects.page.redefineElements();
      setTimeout(function() {
        $(document).trigger('load');

        $.each(app.objects.sticky, function(index, element) {
          element.freezeStickyKit();
        });
      }, 100);
    });


  },



  //////////
  // Helpers

  goToBgPage: function() {
    app.objects.page.callType = undefined;
    if (!(app.vars.browser == 'explorer' && app.vars.browserVersion <= 9)) {
      History.pushState(null, app.objects.page.basePageTitle, this.basePageUrl);
    } else {
      window.location = this.basePageUrl;
    }
  },

  goToOverlayUrl: function(url) {
    app.objects.page.callType = 'overlay';
    History.pushState({state: 'overlay'}, app.objects.page.basePageTitle, url);
  },


};

function overview($el) {
  this.$el = $el;

  // elements
  this.$container = this.$el.find(this.classes.container);
  this.$button = this.$el.find(this.classes.button);
  this.$more = this.$el.find(this.classes.more);
  this.$box = this.$el.find(this.classes.box);
  this.$bar = this.$el.find(this.classes.bar);

  // vars
  this.currentCategory = undefined;
  this.ajaxCall = undefined;
  this.offset = this.settings.limit;
  this.totalArticles = parseInt($el.data('articlesTotal'));
  this.barHeight = this.$bar.outerHeight();

  // init
  this.init();
}

overview.prototype = {
  constructor: overview,

  settings: {
    limit: 7,
    appearDelay: 100, //ms
    urlDelimitter: '?c=',
  },

  classes: {
    container: '.js-overview-container',
    button: '.js-overview-button',
    more: '.js-overview-more',
    item: '.js-overview-item',
    box: '.js-overview-box',
    bar: '.js-overview-bar',
  },

  init: function() {
    this.layoutBlocks();
    this.getInitialCategory();
    this.addListener();
    this.showLoadMore();
  },

  addListener: function() {
    this.$more.on('click', {self: this}, this.moreClickHandler);
    this.$button.on('click', {self: this}, this.buttonClickHandler);
    $(window).off('statechange.overview');
    $(window).on('statechange.overview', {self: this}, this.stateChangeHandler);
  },

  getInitialCategory: function() {
    var $activeButton = this.$button.filter('.' + app.names.isActive);
    this.currentCategory = $activeButton.data('category');
  },

  moreClickHandler: function(event) {
    var self = event.data.self;
    self.loadTeasers('more');
  },

  buttonClickHandler: function(event) {
    var self = event.data.self;
    var category = $(this).data('category');
    var oldUrl = location.href;
    var oldUrlSplit = oldUrl.split(self.settings.urlDelimitter);
    if (oldUrlSplit.length) {
      oldUrl = oldUrlSplit[0];
    }
    var lastChar = oldUrl.substr(oldUrl.length - 1);
    if (lastChar == '/') {
      oldUrl = oldUrl.slice(0, -1);
    }
    var url = oldUrl + self.settings.urlDelimitter + category;
    app.objects.page.callType = 'overview';
    History.pushState({state: 'overview'}, app.objects.overlay.basePageTitle, url);
  },


  stateChangeHandler: function(event) {
    var self = event.data.self;
    var currentState = History.getState();

    if (currentState.data.state == 'overview') {
      var url = currentState['url'];
      var category = url.split(self.settings.urlDelimitter);
      category = category[1];
      self.showNewCategory(category);
    }
  },

  showNewCategory: function(category) {
    var self = this;
    self.currentCategory = category;

    self.$button.filter('.' + app.names.isActive).removeClass(app.names.isActive);
    self.$button.filter('[data-category="' + category + '"]').addClass(app.names.isActive);

    app.objects.scrollToElement.scroll(self.$el);
    self.loadTeasers('new');
  },

  layoutBlocks: function() {
    var self = this;
    self.$container.masonry({
      transitionDuration: 0,
    });

    self.animateItemsIn(self.$container.find(self.classes.item));
  },

  loadTeasers: function(mode) {
    var self = this;

    if (mode == 'more') {
      app.objects.preloader.showPreloader(self.$more, '', 'small');
    } else {
      app.objects.preloader.showPreloader(self.$box);
      self.$container.addClass(app.names.isDisabled);
      self.offset = 0;
    }

    if (self.ajaxCall != undefined) {
      self.ajaxCall.abort();
    }
    self.ajaxCall = $.ajax({
      url: app.vars.parameters['article-overview-url'],
      method: 'POST',
      data: {
        category: self.currentCategory,
        offset: self.offset,
        limit: self.settings.limit,
      },
    })
    .done(function(response) {



      response = $.parseJSON(response);
      var message = response['message'];
      if (response['status'] == 'success') {
        var $html = $(response['html']);
        if (mode == 'more') {
          self.$container.append($html).masonry('appended', $html).masonry();
          self.animateItemsIn($html);
          app.objects.preloader.hidePreloader(self.$more);
        } else {

          self.$box.addClass(app.names.isHidden);
          setTimeout(function() {
            self.$container.masonry('destroy').html($html);
            self.layoutBlocks();
            app.objects.preloader.hidePreloader(self.$box);
            self.$container.removeClass(app.names.isDisabled);
            self.$box.removeClass(app.names.isHidden);
          }, app.settings.duration * 2);
        }

        var itemCount = $html.filter(self.classes.item).length;

        self.offset += itemCount;

        if (itemCount < self.settings.limit) {
          self.$more.hide();
        } else {
          self.$more.show();
        }
      }

      self.ajaxCall = undefined;
    });
  },

  animateItemsIn: function($items) {
    var self = this;
    $items.each(function(index) {
      var $item = $(this);
      setTimeout(function() {
        $item.removeClass(app.names.isNew);
      }, self.settings.appearDelay * index);
    });
    $(window).lazyLoadXT();
    $(window).trigger('load');
    setTimeout(function() {
      // $(window).lazyLoadXT();
      $(window).trigger('resize');
    }, 200);
  },

  showLoadMore: function() {
    if (this.totalArticles > this.settings.limit) {
      this.$more.show();
    }
  },


};

function page() {
  this.$pageContainer = $(this.classes.pageContainer);
  this.$footer = $(this.classes.footer);

  this.basePageUrl = this.getBasePageUrl();
  this.basePageTitle = $('title').data('baseTitle');

  self.pageCall = undefined;
  self.currentAnimation = undefined;

  self.callType = undefined;

  this.init();
}

page.prototype = {
  constructor: page,

  settings: {
    duration: app.settings.duration * 2.5,
    movement: 50,
    animation: 'top',
  },

  classes: {
    pageContainer: '.js-page-container',
    footer: '.js-page-footer',
  },

  names: {
    isAbsolute: 'is-absolute',
  },

  init: function() {
    this.getBasePageUrl();
    this.addListeners();
  },

  redefineElements: function() {
    this.$pageContainer = $(this.classes.pageContainer);
    this.$footer = $(this.classes.footer);
  },

  addListeners: function() {
    $('body').on('click', 'a[target="_parent"]', {self: this}, this.linkClickHandler);
    $(window).on('statechange', {self: this}, this.stateChangeHandler);
  },

  linkClickHandler: function(event) {
    if (!(app.vars.browser == 'explorer' && app.vars.browserVersion <= 9)) {
      event.preventDefault();
      var self = event.data.self;
      var $link = $(this);
      var animation = self.settings.animation;
      var linkAnimation = $link.data('pageAnimation');
      if (linkAnimation != undefined && linkAnimation != '') {
        animation = linkAnimation;
      }

      var url = $link.attr('href');
      self.goToPageUrl(url, animation);
    }
  },


  stateChangeHandler: function(event) {
    var self = event.data.self;
    var currentState = History.getState();
    var url = currentState['url'];

    if (currentState.data.state == 'page' || self.callType == 'page') {
      var animation;
      if (currentState.data.animation != undefined) {
        self.currentAnimation = currentState.data.animation;
      } else {
        self.currentAnimation = self.settings.animation;
      }
      self.openPage(url);
    }

  },





  ///////
  // Main

  openPage: function(url) {
    var self = this;

    app.objects.header.closeSubmenu();

    // show preloader
    app.objects.preloader.showPreloader(self.$pageContainer.parent());
    self.$pageContainer.velocity({
      opacity: 0.6,
    }, {
      duration: self.settings.duration / 4,
      complete: function() {
        self.pageAjaxCall(url);
      },
    });
    self.$footer.velocity({
      opacity: 0.2,
    }, {
      duration: self.settings.duration / 4,
    });

  },


  pageAjaxCall: function(url) {
    var self = this;

    if (self.pageCall != undefined) {
      self.pageCall.abort();
    }
    self.pageCall = $.ajax({
      url: url,
      method: 'POST',
      cache: true,
      data: {'ajaxPageCall': true},
    })
    .done(function(msg) {
      self.pageContentLoaded(msg);
    });
  },

  pageContentLoaded: function(msg) {
    var self = this;
    var $msg = $(msg);

    var oldContainerHeight = this.$pageContainer.outerHeight();

    app.objects.track.trackPage();

    $msg.css({
      height: oldContainerHeight,
      top: self.$pageContainer.offset().top,
    });

    this.removeGlobalListeners();
    this.$pageContainer.after($msg);
    app.objects.initModules.initLocal($msg);
    $(window).lazyLoadXT();

    if(typeof OneTrust !== 'undefined'){
      OneTrust.initializeCookiePolicyHtml();
      $('.ot-sdk-show-settings').off('click').on('click', function(){
        OneTrust.ToggleInfoDisplay();
      });
    }

    // setTimeout(function() {
    // $(window).lazyLoadXT();
    // }, 1000);
    app.objects.preloader.hidePreloader(self.$pageContainer.parent());

    var translateYOld = 0;
    var translateXOld = 0;
    var translateYNew = 0;
    var translateXNew = 0;
    switch (self.currentAnimation) {
      case 'top':
      translateYOld = self.settings.movement + 'px';
      translateYNew = '-' + self.settings.movement + 'px';
      break;
      case 'right':
      translateXOld = '-' + self.settings.movement + 'px';
      translateXNew = self.settings.movement + 'px';
      break;
      case 'left':
      translateXOld = self.settings.movement + 'px';
      translateXNew = '-' + self.settings.movement + 'px';
      break;
    }

    self.$pageContainer.velocity({
      translateY: translateYOld,
      translateX: translateXOld,
      opacity: 0,
    }, {
      easing: app.settings.easingIn,
      duration: self.settings.duration / 2,
      complete: function() {
        $(document).scrollTop(0);
        app.objects.header.oldScrollPos = 0;
        $(window).trigger('scroll');
        $msg.css('height', 'auto');
        self.$footer.css('opacity', 0);
      },
    });

    if (translateYNew != 0) {
      $.Velocity.hook($msg, 'translateY', translateYNew);
    }
    if (translateXNew != 0) {
      $.Velocity.hook($msg, 'translateX', translateXNew);
    }
    $msg.velocity({
      opacity: 1,
      translateX: 0,
      translateY: 0,
    }, {
      easing: app.settings.easing,
      duration: self.settings.duration,
      delay: self.settings.duration / 2,
      complete: function() {
        self.$pageContainer.remove();
        self.$pageContainer = $msg;
        $msg.removeClass(app.names.isHidden).removeAttr('style');

        self.$footer.velocity({
          opacity: 1,
        }, {
          duration: self.settings.duration / 2,
        });

        self.$pageContainer.waitForImages(function() {
          $(document).trigger('load');
          $(window).trigger('resize');
          // $.fn.matchHeight._update();
        });

        setTimeout(function() {
          $(document).trigger('load');
          $(window).trigger('resize');
        }, 100);
      },
    });

  },

  removeGlobalListeners: function() {
    $(window).off('scroll.scrollnav');
    $(window).off('resize.scrollnav');
  },





  //////////
  // Helpers

  getBasePageUrl: function() {
    var currentUrl = window.location.href;
    var basecurrentUrl = currentUrl.split('?');
    return basecurrentUrl[0];
  },

  goToPageUrl: function(url, animation) {
    animation = animation || this.settings.animation;
    var anchor = url.split('#')[1];
    url = url.split('#')[0];
    if (anchor == undefined) anchor = false;
    this.callType = 'page';
    History.pushState({state: 'page', anchor: anchor, animation: animation}, this.basePageTitle, url);

    if (anchor && anchor.indexOf('filter') === 0) {
      window.location.hash = anchor
    }
  },

  goBack: function() {
    History.back();
  },

};

function sticky($el) {
  this.$el = $el;

  this.stickyOn = false;

  // init
  this.init();
}

sticky.prototype = {
  constructor: sticky,

  init: function() {
    this.initStickyKit();
  },

  stateChange: function() {
    this.initStickyKit(); 
  },

  initStickyKit: function() {
    var self = this;
    
    var offset = 0;
    if (!Gridle.isActive('lg') && app.objects.header) {
      offset = app.objects.header.headerHeight;
    }

    if (!self.stickyOn) {
      self.stickyOn = true;
      this.$el.stick_in_parent({
        offset_top: offset,
      });
    }

  },

  removeStickyKit: function() {
    var self = this;
    if (self.stickyOn) {
      self.$el.trigger('sticky_kit:detach');
      self.stickyOn = false;
    }
  },

  freezeStickyKit: function() {
    var self = this;
    self.$el.trigger('sticky_kit:freeze');
  },


  unfreezeStickyKit: function() {
    var self = this;
    self.$el.trigger('sticky_kit:unfreeze');
  },



};

function search($el) {
  this.$el = $el;

  this.$info = $el.find(this.classes.info);
  this.$field = $el.find(this.classes.field);
  this.$more = $el.find(this.classes.more);
  this.$results = $el.find(this.classes.results);
  this.$header = $el.find(this.classes.header);
  this.$containerProducts = $el.find(this.classes.containerProducts);
  this.$containerArticles = $el.find(this.classes.containerArticles);
  this.$countProducts = $el.find(this.classes.countProducts);
  this.$countArticles = $el.find(this.classes.countArticles);
  this.$topLink = $(this.classes.topLink);
  this.$boxProducts = $(this.classes.boxProducts);
  this.$boxArticles = $(this.classes.boxArticles);
  this.$noResultsProducts = $(this.classes.noResultsProducts);
  this.$noResultsArticles = $(this.classes.noResultsArticles);

  // vars
  this.ajaxCall = undefined;
  this.searchStarted = false;
  this.typingTimeout = undefined;
  this.searchPageOpen = false;

  this.init();
}

search.prototype = {
  constructor: search,

  settings: {
    initialProducts: 4,
    initialArticles: 5,
    minStringLength: 3,
    searchParameter: 'search',
  },

  classes: {
    info: '.js-search-info',
    field: '.js-search-field',
    more: '.js-search-more',
    results: '.js-search-results',
    header: '.js-search-header',
    containerProducts: '.js-search-container-products',
    containerArticles: '.js-search-container-articles',
    countProducts: '.js-search-count-products',
    countArticles: '.js-search-count-articles',
    topLink: '.js-search-top-link',
    boxProducts: '.js-search-box-products',
    boxArticles: '.js-search-box-articles',
    noResultsProducts: '.js-search-no-results-products',
    noResultsArticles: '.js-search-no-results-articles',
  },

  names:{
  },

  init: function(){
    this.initialSetup();
    this.addListeners();
    this.markTopLinkActive();
  },

  initialSetup: function(){
    this.$field.focus();

    if(this.$field.val != ''){
      this.launchSearch('new');
    }
  },

  addListeners: function(){
    this.$field.on('keypress', {self: this}, this.fieldKeyDownHandler);
    this.$more.on('click', {self: this}, this.moreClickHandler);
    this.$topLink.on('click', {self: this}, this.topLinkClickHandler);
    $(window).off('statechange.search');
    $(window).on('statechange.search', {self: this}, this.stateChangeHandler);
  },

  stateChangeHandler: function(event){
    var self = event.data.self;
    if(self.searchPageOpen){
      self.markTopLinkUnactive();
    }
  },

  topLinkClickHandler: function(event){
    var self = event.data.self;
    if(self.searchPageOpen){
      app.objects.page.goBack();
      event.preventDefault();
      event.stopPropagation();
    }
  },

  fieldKeyDownHandler: function(event){
    var self = event.data.self;
    if(event.which == '13'){
      event.preventDefault();
      self.launchSearch('new'); 
      self.typingTimeout = undefined;
      return false;
    }

    if(self.typingTimeout != undefined){
      clearTimeout(self.typingTimeout);
    }
    self.typingTimeout = setTimeout(function() {
      var string = self.$field.val();
      if( string.length >= self.settings.minStringLength ){
        self.launchSearch('new');
      }
    }, 500);
  },

  moreClickHandler: function(event){
    var self = event.data.self;
    var type = $(this).data('type');

    app.objects.preloader.showPreloader($(this), '', 'small');
    var ids = [];
    $('[data-search-product-id]').each(function(index) {
      ids.push($(this).data('search-product-id'));
    });
    self.searchForString('more', type, ids);
  },

  launchSearch: function(mode, type){
    var self = this;
    type = type || 'both';

    var myCustomEvent = new Event('closenav');
    document.dispatchEvent(myCustomEvent);

    app.objects.preloader.showPreloader(self.$header, '', 'big');
    self.$results.velocity({
      opacity: 0.2,  
    },{
      duration: app.settings.duration,
      complete: function(){
        self.searchForString(mode, type, []);
      }
    });

  },

  searchForString: function(mode, type, ids){
    var self = this;

    type = type || 'both';

    var string = self.$field.val();
    if( string.length < self.settings.minStringLength ){
      app.objects.preloader.hidePreloader(self.$header);
      self.$results.velocity({
        opacity: 1,  
      },{
        duration: app.settings.duration,  
      });
      return false;
    } 

    string = self.sanitizeString(string);

    var url = '?' + self.settings.searchParameter + '=' + string;
    app.objects.page.callType = 'search';
    History.pushState({state: 'search'}, app.objects.page.basePageTitle, url);

    if(self.ajaxCall != undefined){
      self.ajaxCall.abort();
    }
    self.ajaxCall = $.ajax({
      url: app.vars.parameters['search-url'],
      method: 'POST',
      data: {
        string: string,
        mode: mode,
        type: type,
        ids: ids,
        initialProducts: self.settings.initialProducts,
        initialArticles: self.settings.initialArticles,
      }
    })
    .done(function(response) {
      response = $.parseJSON(response);
      var message = response['message'];
      if(response['status'] == 'success'){

        var $htmlProducts = $(response['html_products']);
        var $htmlArticles = $(response['html_articles']);

        if(mode == 'new'){
          self.$containerProducts.html($htmlProducts);
          self.$containerArticles.html($htmlArticles);
          self.updateCounts(response['total_products'], response['total_articles'])
          self.updateEmptyStates(response['total_products'], response['total_articles'])
          app.objects.preloader.hidePreloader(self.$header);
          self.$results.velocity({
            opacity: 1,  
          },{
            duration: app.settings.duration,
            queue: false,
          });
        } else {
          app.objects.preloader.hidePreloader( self.$more );
          if(type == 'products'){
            self.$containerProducts.append($htmlProducts);
          } else if(type == 'articles'){
            self.$containerArticles.append($htmlArticles);
          }
        }

        self.toggleMoreButtons(type, mode, response);
        self.showResults();


      } else {

      }


    });

  },

  updateCounts: function(countProducts, countArticles){
    var self = this;

    self.$countProducts.text(countProducts);
    self.$countArticles.text(countArticles);

  },

  updateEmptyStates: function(countProducts, countArticles){
    var self = this;

    if(countProducts == 0){
      self.$boxProducts.hide();
      self.$noResultsProducts.show();
    } else {
      self.$boxProducts.show();
      self.$noResultsProducts.hide();
    }

    if(countArticles == 0){
      self.$boxArticles.hide();
      self.$noResultsArticles.show();
    } else {
      self.$boxArticles.show();
      self.$noResultsArticles.hide();
    }


  },

  toggleMoreButtons: function(type, mode, response){
    var self = this;

    var $moreProducts = self.$more.filter('[data-type="products"]');
    var $moreArticles = self.$more.filter('[data-type="articles"]');
    if(mode == 'new'){
      if(type == 'both' || type == 'products'){
        if( response['total_products'] > self.settings.initialProducts){
          $moreProducts.css('display', 'inline-block');
        } else {
          $moreProducts.hide();
        }
      }
      if(type == 'both' || type == 'articles'){
        if( response['total_articles'] > self.settings.initialArticles){
          $moreArticles.css('display', 'inline-block');
        } else {
          $moreArticles.hide();
        }
      }
    } else {
      if(type == 'both' || type == 'products'){
        $moreProducts.hide();
      }
      if(type == 'both' || type == 'articles'){
        $moreArticles.hide();
      }
    }
  },

  showResults: function(){
    var self = this;

    if(!self.searchStarted){
      self.searchStarted = true;
      self.$results.velocity('slideDown',{
        easing: app.settings.easingIn,
        duration: app.settings.duration,
        queue: false,
        complete: function(){
          if(app.objects.scrollNav){
            app.objects.scrollNav.getSectionPositions();
          }
        }
      });;
      self.$info.velocity({
        opacity: 1,  
      },{
        duration: app.settings.duration,
      });
    }
  },

  markTopLinkActive: function(){
    var self = this;
    self.searchPageOpen = true;
    self.$topLink.addClass(app.names.isActive);
  },

  markTopLinkUnactive: function(){
    var self = this;
    self.searchPageOpen = false;
    self.$topLink.removeClass(app.names.isActive);
  },

  sanitizeString: function(string){
    var $div = $('<div>');
    var escaped = $div.text(string).html();
    return escaped;
  },

};

function cookie($el) {
  this.$el = $el;

  // elements
  this.$accept = this.$el.find(this.classes.accept);

  // init
  this.init();
}

cookie.prototype = {
  constructor: cookie, 

  settings: {
    cookieName: 'merzCookiesAccepted',
    cookieValue: 'accepted',
    cookieExpiration: 90, //days
    distance: '130%',
  },  

  classes: {
    accept: '.js-cookie-accept',
  },

  init: function(){
    this.addListener();
  },

  addListener: function(){
    this.$accept.on('click', {self: this}, this.acceptClickHandler);
  },

  acceptClickHandler: function(event){
    var self = event.data.self;
    self.acceptCookie();
  },

  acceptCookie: function(){
    var self = this;
    Cookies.set(self.settings.cookieName, self.settings.cookieValue, { expires: self.settings.cookieExpiration });
    setTimeout(function() {
      location.reload();
    }, 200);

    // self.$el.velocity({
    //     translateY: self.settings.distance,
    // },{
    //   easing: app.settings.easingIn,
    //   duration: app.settings.duration*1,
    //   complete: function(){
    //     self.$el.remove();
    //   }
    // });
  },
};

function socialShare() {
  this.init();
}

socialShare.prototype = {

  vars: {
    listenerAdded: false
  },

  classes: {
    trigger: 'js-share'
  },

  config: {
    default: {
      popupWidth: 520,
      popupHeight: 350,
      urlKey: 'url'
    },
    facebook: {
      url: "https://www.facebook.com/sharer/sharer.php",
      urlKey: 'u'
    },
    twitter: {
      url: "https://twitter.com/intent/tweet/"
    },
    linkedin: {
      url: "https://www.linkedin.com/shareArticle"
    },
    googleplus: {
      url: "https://plus.google.com/share"
    },
    pinterest: {
      url: "https://www.pinterest.com/pin/create/button/",
      popupHeight: "full",
      popupWidth: "half",
    },
    email: {
      overlay: 'ajax/share.html'
    }
  },

  init: function(){
    this.addListener();
  },

  addListener: function(){
    jQuery(document)
    .on('click', '.' + this.classes.trigger, {self:this}, this.clickHandler);
  },


  clickHandler: function(event){

    event.preventDefault();

    var self = event.data.self;
    var $clicked = jQuery(this);
    var type = $clicked.data("type") || "facebook";
    var shareUrl = $clicked.data("shareUrl") || escape(window.location.href);
    var mediaUrl = $clicked.data("mediaUrl") || '';
    var $window = jQuery(window);

    var config = jQuery.extend({}, self.config.default, self.config[type]);

    if (!config.url) {
      console.error('Sharing is not setup for "' + type + '"');
      return
    };


    var url = config.url;


      // Add parameter
      var parameter = [];
      parameter.push( config.urlKey + "=" + shareUrl);
      if(mediaUrl != ''){
        parameter.push( 'media' + "=" + mediaUrl);
      }
      parameter = "?" + parameter.join("&");
      url += parameter;

      // Convert "string" to height
      if (config.popupHeight == "full") {
        config.popupHeight = jQuery(window).height();
      };

      if (config.popupWidth == "half") {
        config.popupWidth = jQuery(window).width() / 2;

      };


      var windowLeft = window.screenLeft ? window.screenLeft : window.screenX;
      var windowTop = window.screenTop ? window.screenTop : window.screenY;


      var top = windowTop + ($window.height() / 2 - config.popupHeight / 2);
      var left = windowLeft + ($window.width() / 2 - config.popupWidth / 2);

      window.open(url, 'sharePopUp', 'height='+config.popupHeight + ', width='+ config.popupWidth + ', top=' + top + ', left=' + left + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    }




  };
function hoverTarget($el) {
  this.$el = $el;

  // init
  this.init();
}

hoverTarget.prototype = {
  constructor: hoverTarget,

  classes:{
    link: '.js-hover-target'
  },

  names:{
    isHover: 'is-hover'
  },

  init: function(){
    this.addListeners();
  },

  addListeners: function(){
    $(document).on('mouseenter', this.classes.link, {self: this}, this.buttonMouseEnterHandler)
    $(document).on('mouseleave', this.classes.link, {self: this}, this.buttonMouseLeaveHandler)
  },

  buttonMouseEnterHandler: function(event){
    var self = event.data.self;
    var target = $(this).closest( $(this).data('hoverTarget') );
    target.addClass(self.names.isHover);
  },

  buttonMouseLeaveHandler: function(event){
    var self = event.data.self;
    var target = $(this).closest( $(this).data('hoverTarget') );
    target.removeClass(self.names.isHover);
  },


};


function timeline($el) {
  this.$el = $el;

  // elements
  this.$dot = $el.find(this.classes.dot);
  this.$item = $el.find(this.classes.item);
  this.$area = $el.find(this.classes.area);
  this.$range = $el.find(this.classes.range);
  this.$nav = $el.find(this.classes.nav);
  this.$navButton = $el.find(this.classes.navButton);
  this.$box = $el.find(this.classes.box);
  this.$teaser = $el.find(this.classes.teaser);
  this.$teaserButton = $el.find(this.classes.teaserButton);
  this.$back = $el.find(this.classes.back);
  this.$content = $el.find(this.classes.content);
  this.$lineRange = $el.find(this.classes.lineRange);
  this.$arrowNext = $el.find(this.classes.arrowNext);
  this.$arrowPrev = $el.find(this.classes.arrowPrev);

  // vars
  this.currentRange = undefined;
  this.currentRangeIndex = 0;
  this.currentRangeIndexTemp = 0;
  this.currentItem = undefined;
  this.owl = undefined;
  this.rangeCount = undefined;
  this.initialNavTranslate = undefined;
  this.boxHeight = undefined;
  this.teaserHeight = undefined;

  // init
  this.init();
}

timeline.prototype = {
  constructor: timeline,

  settings: {
    teaserEasing: app.settings.easingInOut,
    teaserDuration: app.settings.duration * 2,
  },

  classes: {
    dot: '.js-timeline-dot',
    item: '.js-timeline-item',
    area: '.js-timeline-area',
    range: '.js-timeline-range',
    nav: '.js-timeline-nav',
    navButton: '.js-timeline-nav-button',
    box: '.js-timeline-box',
    teaser: '.js-timeline-teaser',
    teaserButton: '.js-timeline-teaser-button',
    back: '.js-timeline-back',
    content: '.js-timeline-content',
    lineRange: '.js-timeline-line-range',
    arrowNext: '.js-timeline-next',
    arrowPrev: '.js-timeline-prev',
  },

  init: function() {

    this.addListener();
    this.initCarousel();
    this.getRangeCount();
    this.getInitialNavTranslate();
    this.getFirstRange();
    this.showFirstItemFromRange();
    this.markNavButton();
    this.measureBox();
    this.gridleUpdateHandler();
    this.loadLazyImages();

  },

  initCarousel: function() {
    var self = this;

    self.owl = self.$area.owlCarousel({
      dots: false,
      loop: false,
      center: false,
      items: 1,
      smartSpeed: app.settings.duration * 2,
      nav: false,
      autoPlay: false,
    });

    self.owl.on('change.owl.carousel', function(event) {
      var index = event.property.value;
      self.currentRangeIndex = index;
      self.currentRange = self.$range.eq(index).data('range');
      self.markNavButton();
    });

    self.owl.on('changed.owl.carousel', function(event) {
      setTimeout(function() {
        var index = event.property.value;
        var dir;
        if (index < self.currentRangeIndexTemp) {
          dir = 'prev';
        } else {
          dir = 'next';
        }
        self.loadLazyImages();

        self.currentRangeIndexTemp = index;
        self.showFirstItemFromRange(dir);
      }, 10);
      
    });
  },

  gridleUpdateHandler: function() {
    var self = this;
    self.updateResponsivePositioning();
    Gridle.on('update', function() {
      self.updateResponsivePositioning();
    });
  },  

  addListener: function() {
    this.$dot.on('mouseenter', {self: this}, this.dotMouseEnterHandler);
    this.$dot.on('click', {self: this}, this.dotClickHandler);
    this.$navButton.on('click', {self: this}, this.navButtonClickHandler);
    this.$lineRange.on('click', {self: this}, this.lineRangeClickHandler);
    this.$teaserButton.on('click', {self: this}, this.teaserButtonClickHandler);
    this.$back.on('click', {self: this}, this.backClickHandler);
    this.$arrowPrev.on('click', {self: this}, this.arrowPrevClickHandler);
    this.$arrowNext.on('click', {self: this}, this.arrowNextClickHandler);
  },

  dotMouseEnterHandler: function(event) {
    var self = event.data.self;
    var $item = $(this).closest(self.classes.item);
    var itemId = $item.data('itemId');
    self.showItem(itemId);
  },
  
  dotClickHandler: function(event) {
    var self = event.data.self;
    var $item = $(this).closest(self.classes.item);
    var itemId = $item.data('itemId');
    self.showItem(itemId);
  },

  navButtonClickHandler: function(event) {
    var self = event.data.self;
    var range = $(this).data('range');
    self.showRange(range);
  },

  lineRangeClickHandler: function(event) {
    var self = event.data.self;
    var range = $(this).data('range');
    self.showRange(range);
  },

  teaserButtonClickHandler: function(event) {
    var self = event.data.self;
    self.showBox();
  },

  backClickHandler: function(event) {
    var self = event.data.self;
    self.hideBox();
  },

  arrowPrevClickHandler: function(event) {
    var self = event.data.self;
    self.showSiblingItem('prev');
  },

  arrowNextClickHandler: function(event) {
    var self = event.data.self;
    self.showSiblingItem('next');
  },

  showItem: function(itemId) {
    var self = this;

    var $oldItem = self.$item.filter('.' + app.names.isActive);
    var $newItem = self.$item.filter('[data-item-id="' + itemId + '"]');

    $oldItem.removeClass(app.names.isActive);
    $newItem.addClass(app.names.isActive);

    self.currentItem = itemId;

    self.toggleArrows();
  },

  showRange: function(range) {
    var self = this;
    var $range = self.$navButton.filter('[data-range="' + range + '"]');
    var index = $range.index();
    self.currentRangeIndex = index;
    self.owl.trigger('to.owl.carousel', index);
    self.markNavButton();
  },

  showFirstItemFromRange: function(dir) {
    var self = this;
    var $range = self.$range.filter('[data-range="' + self.currentRange + '"]');
    var $items = $range.find(self.classes.item);
    var $item;
    if (dir === 'next' || dir == undefined) {
      $item = $items.first();
    } else {
      $item = $items.last();
    }
    var itemId = $item.data('itemId');
    self.showItem(itemId);
  },

  getFirstRange: function() {
    var $firstRange = this.$range.eq(0);
    this.currentRange = $firstRange.data('range');
  },

  markNavButton: function() {
    var self = this;
    self.$navButton.filter('.' + app.names.isActive).removeClass(app.names.isActive);
    var $newButton = self.$navButton.filter('[data-range="' + self.currentRange + '"]');
    $newButton.addClass(app.names.isActive);

    var index = $newButton.index();

    var unit = self.initialNavTranslate / self.rangeCount;
    var distance = -(unit * index) + 'px';
    self.$nav.velocity({
      translateX: distance,  
    }, {
      easing: app.settings.easing,
      duration: app.settings.duration * 3,
      queue: false,
    });

    var opacityIndex = 0;
    self.$navButton.each(function(index) {
      if (index > self.currentRangeIndex) {
        var opacity = 1 - (opacityIndex / self.rangeCount);
        $(this).css({
          opacity: opacity,
        });
        opacityIndex++;
      } else {
        $(this).css('opacity', 1);
      }
    });

  },

  showBox: function() {
    var self = this;

    self.loadLazyImages();

    self.$box.css('z-index', 5);
    self.$box.addClass(app.names.isOpen);
    self.$box.velocity({
      height: self.boxHeight,  
    }, {
      easing: self.settings.teaserEasing,
      duration: self.settings.teaserDuration,
    });
    self.$el.velocity({
      height: self.boxHeight,  
    }, {
      easing: self.settings.teaserEasing,
      duration: self.settings.teaserDuration,
      complete: function() {
        // app.objects.scrollToElement.scroll(self.$el);
      },
    });

  },


  hideBox: function() {
    var self = this;
    self.$box.css('z-index', 5);
    self.$box.removeClass(app.names.isOpen);
    self.$box.velocity({
      height: 0,  
    }, {
      easing: self.settings.teaserEasing,
      duration: self.settings.teaserDuration,
    });
    self.$el.velocity({
      height: self.teaserHeight,  
    }, {
      easing: self.settings.teaserEasing,
      duration: self.settings.teaserDuration,
    });
  },

  getRangeCount: function() {
    this.rangeCount = this.$navButton.length;
  },

  getInitialNavTranslate: function() {
    this.initialNavTranslate = -parseInt(this.$nav.css('margin-right'));
  },

  measureBox: function() {
    this.boxHeight = this.$box.outerHeight();
    this.teaserHeight = this.$teaser.outerHeight();
        // this.$box.css('height', 0);

      },

      updateResponsivePositioning: function() {
        var self = this;
        if (Gridle.isActive('lg')) {
          self.$content.removeAttr('style');
        } else {
          self.$content.each(function() {
            $(this).css('left', $(this).data('left'));
          });
        }
      },

      showSiblingItem: function(dir) {
        var self = this;

        var $currentItem = self.$item.filter('[data-item-id="' + self.currentItem + '"]');

        var $targetItem;
        if (dir === 'prev') {
          $targetItem = $currentItem.prev();
        } else {
          $targetItem = $currentItem.next();
        }

        if ($targetItem.length) {
          var targetItemId = $targetItem.data('itemId');
          self.showItem(targetItemId);
        } else {
          var $currentRange = self.$navButton.filter('[data-range="' + self.currentRange + '"]');

          var $targetRange;
          if (dir === 'prev') {
            $targetRange = $currentRange.prev();
          } else {
            $targetRange = $currentRange.next();
          }
          var targetRange = $targetRange.data('range');
          self.showRange(targetRange);
        }

      },

      toggleArrows: function() {
        var self = this;

        var $currentItem = self.$item.filter('[data-item-id="' + self.currentItem + '"]');

        if (self.currentRangeIndex === 0) {
          $prevCurrentItem = $currentItem.prev();
          if (!$prevCurrentItem.length) {
            self.$arrowPrev.hide();
          } else {
            self.$arrowPrev.show();
          }
        } else {
          self.$arrowPrev.show();

        }

        if (self.currentRangeIndex === self.rangeCount - 1) {
          $nextCurrentItem = $currentItem.next();
          if (!$nextCurrentItem.length) {
            self.$arrowNext.hide();
          } else {
            self.$arrowNext.show();
          } 
        } else {
          self.$arrowNext.show();
        }
      },

      loadLazyImages: function() {
        var $images = this.$box.find('[data-bg]');
        $images.each(function() {
          $(this).css('background-image', 'url(' + $(this).attr('data-bg') + ')');
        });
      },

    };

function toggleElement($el) {
  this.$el = $el;

  this.settings = {};

  var data = this.$el.data();

  // settings
  ( data['toggleTarget'] !== undefined ) ? this.settings.target = data['toggleTarget'] : this.settings.target = this.defaults.target;
  ( data['toggleScroll'] !== undefined ) ? this.settings.scroll = data['toggleScroll'] : this.settings.scroll = this.defaults.scroll;
  ( data['toggleAnimation'] !== undefined ) ? this.settings.animation = data['toggleAnimation'] : this.settings.animation = this.defaults.animation;

  // init
  this.init();
  this.parse();
}

toggleElement.prototype = {
  constructor: toggleElement,

  settings:{
    toggleDuration: app.settings.duration*8
  },

  defaults:{
    target: undefined,
    scroll: false,
    animation: 'slide',
  },

  classes:{
    button: '.js-toggle-btn'
  },

  init: function(){
  },

  parse: function(){
    this.addListener();
  },

  addListener: function(){
    this.$el.on('click', {self: this}, this.buttonClickHandler);
  },

  buttonClickHandler: function(event){
    var self = event.data.self;
    event.preventDefault();
    var $button = $( this );
    if( $button.hasClass(app.names.isActive) ) {
      self.hideElement();
    } else {
      self.showElement();
    }
  },

  hideElement: function(){
    var self = this;
    var $target = $(self.settings.target);

    // Hide target
    if( self.settings.animation == 'slide' ){
      $target.velocity('slideUp',{
        duration: self.settings.toggleDuration,
        easing: app.settings.easingInOut
      });
    } else if ( self.settings.animation == 'fade' ){
      $target.velocity('fadeOut',{
        duration: self.settings.toggleDuration,
        easing: app.settings.easingInOut
      });
    } else if ( self.settings.animation == 'hard' ){
      $target.hide();
    }


    // Trigger 'closed' event on the target element
    $target.trigger('closed');

    // Mark buttons assigned to the target
    this.markButtons(self.settings.target, 'hide');
  },

  showElement: function(){
    var self = this;
    var $target = $(self.settings.target);

    // Show target
    if( self.settings.animation == 'slide' ){
      $target.velocity('slideDown',{
        duration: self.settings.toggleDuration,
        easing: app.settings.easingInOut
      });
    } else if ( self.settings.animation == 'fade' ){
      $target.velocity('fadeIn',{
        duration: self.settings.toggleDuration,
        easing: app.settings.easingInOut
      });
    } else if ( self.settings.animation == 'hard' ){
      $target.show();
    }

    // Mark buttons assigned to the target
    self.markButtons(self.settings.target, 'show');

    // Trigger event to lazy load images
    $(window).trigger('load');

    // Trigger 'opened' event on the target element
    $target.trigger('opened');

    // Scroll to element
    if(self.settings.scroll){
      self.scrollToElement();
    }
  },

  markButtons: function(target, mode){
    var self = this;
    $buttons = $(self.classes.button + '[data-toggle-target="' + target + '"]');
    if(mode == 'show'){
      $buttons.addClass(app.names.isActive);
    } else {
      $buttons.removeClass(app.names.isActive);
    }
  },

  scrollToElement: function(){
    var self = this;
    var scrollTarget;
    var offset = 0;

    switch( self.settings.scroll ){
      case 'target':
      scrollTarget = $(self.settings.target);
      break;
      case 'this':
      scrollTarget = self.$el;
      break;
    }

    var $header = $('#header');
    if ( $header.css('position') == 'fixed' ) {
      offset = $header.outerHeight();
    }

    scrollTarget.velocity('scroll',{
      duration: self.settings.toggleDuration,
      easing: app.settings.easingInOut,
      offset: -offset
    });

  }

};


function featured($el) {
  this.$el = $el;

  this.$item = $el.find(this.classes.item);

  // vars
  this.featuredOpen = false;

  this.init();
}

featured.prototype = {
  constructor: featured,

  classes: {
    featured: '.js-featured',
    item: '.js-featured-item',
  },


  init: function(){
    this.addListeners();
  },

  addListeners: function(){
    this.$item.on('click', {self: this}, this.itemClickHandler);
    $(document).on('click', {self: this}, this.documentClickHandler);
  },

  itemClickHandler: function(event){
    var self = event.data.self;
    if (Modernizr.touchevents) { 
      if( !$(this).hasClass(app.names.isActive) ){
        event.preventDefault();
        event.stopPropagation();
      }
      self.toggleElement($(this));
    } 
  },

  documentClickHandler: function(event){
    var self = event.data.self;
    if(self.featuredOpen){
        self.closeAllElements();
    }
  },

  toggleElement: function($element){
    var $activeSiblings = this.$item.filter('.' + app.names.isActive);
    $element.toggleClass(app.names.isActive);
    $activeSiblings.toggleClass(app.names.isActive);
    this.featuredOpen = true;
  },

  closeAllElements: function(){
    this.$item.removeClass(app.names.isActive);
    this.featuredOpen = false;
  },  

};

function slider($el) {
  this.$el = $el;

  var data = this.$el.data();

  this.settings = {};

  // settings
  (data['owlDots'] !== undefined) ? this.settings.dots = data['owlDots'] : this.settings.dots = this.defaults.dots;
  (data['owlAutoWidth'] !== undefined) ? this.settings.autoWidth = data['owlAutoWidth'] : this.settings.autoWidth = this.defaults.autoWidth;
  (data['owlNav'] !== undefined) ? this.settings.nav = data['owlNav'] : this.settings.nav = this.defaults.nav;
  (data['owlItems'] !== undefined) ? this.settings.items = data['owlItems'] : this.settings.items = this.defaults.items;
  (data['owlLoop'] !== undefined) ? this.settings.loop = data['owlLoop'] : this.settings.loop = this.defaults.loop;
  (data['owlCenter'] !== undefined) ? this.settings.center = data['owlCenter'] : this.settings.center = this.defaults.center;
  (data['owlMargin'] !== undefined) ? this.settings.margin = data['owlMargin'] : this.settings.margin = this.defaults.margin;
  (data['owlAutoplay'] !== undefined) ? this.settings.autoplay = data['owlAutoplay'] : this.settings.autoplay = this.defaults.autoplay;
  (data['owlRemoveOnMedium'] !== undefined) ? this.settings.removeOnMedium = data['owlRemoveOnMedium'] : this.settings.removeOnMedium = this.defaults.removeOnMedium;
  (data['owlRemoveOnLarge'] !== undefined) ? this.settings.removeOnLarge = data['owlRemoveOnLarge'] : this.settings.removeOnLarge = this.defaults.removeOnLarge;
  
  if (data['owlResponsive'] !== undefined) {
    switch (data['owlResponsive']) {
      case 'home-blog':
      this.settings.responsive = this.responsive.homeBlog;
      break;
      // case 'baby-page':
      //   this.settings.responsive = this.responsive.babyPage;
      //   break;
    }
  } else {
    this.settings.responsive = this.defaults.responsive;
  }

  // callbacks
  if (data['owlOnChanged'] !== undefined) {
    switch (data['owlOnChanged']) {
      case 'featured':
      this.settings.onChanged = this.onChangedFeatured;
      break;
    }
  } else {
    this.settings.onChanged = this.onChangedDefault;
  }

  // init
  this.init();
}

slider.prototype = {
  constructor: slider,

  defaults: {
    dots: true,
    nav: false,
    items: 1,
    loop: false,
    center: false,
    rtl: false,
    margin: false,
    autoplay: false,
    responsive: false,
    removeOnMedium: false,
    removeOnLarge: false,
    autoWidth: false,
  },

  responsive: {
    homeBlog: {
      0: {
        dots: true,
        items: 1,
        slideBy: 1,
      },
      640: {
        dots: true,
        items: 2,
        slideBy: 2,
      },
      1025: { 
        dots: false,
        items: 3,
        mouseDrag: false,
        touchDrag: false,
      },
    }
  },

  init: function() {
    this.initOwlCarousel();
    this.gridleUpdateHandler();
  },


  gridleUpdateHandler: function() {
    var self = this;
    Gridle.on('update', function() {
      if (self.settings.removeOnMedium && Gridle.isActive('md') && self.$el.hasClass('owl-carousel')) {
        self.$el.trigger('destroy.owl.carousel');
        self.$el.removeClass('owl-carousel').removeClass('owl-theme');
      } 
      if (self.settings.removeOnMedium && !Gridle.isActive('md') && !self.$el.hasClass('owl-carousel')) {
        self.initOwlCarousel();
      }
    });
  },


  initOwlCarousel: function() {
    var self = this;

    if (self.settings.removeOnMedium && Gridle.isActive('md')) {
      return false;
    }

    this.$el.addClass('owl-carousel').addClass('owl-theme');

    this.$el.owlCarousel({
      items: self.settings.items,
      loop: self.settings.loop,
      center: self.settings.center,
      smartSpeed: app.settings.duration * 3,
      autoplay: self.settings.autoplay,
      margin: self.settings.margin,
      autoplayTimeout: 7000,
      autoplayHoverPause: true,
      autoHeight: false,
      dots: self.settings.dots,
      nav: self.settings.nav,
      responsive: self.settings.responsive,
      navText: [, ],
      onChanged: self.settings.onChanged,
      autoWidth: self.settings.autoWidth,
      onInitialized: self.onInitialized,
    });

  },

  // callbacks
  onInitialized: function() {
    $(window).lazyLoadXT();
  },

  // on changed
  onChangedDefault: function(event) {
    setTimeout(function() {
      $(window).trigger('resize');
    }, 100);
    setTimeout(function() {
      $(window).trigger('scroll');
    }, 200);
  },

  onChangedFeatured: function(event) {
    if (app.objects.featured != undefined) {
      app.objects.featured.closeAllElements();
    }
  },

};


function dropdown($el) {
  this.$el = $el;

  // elements
  this.$button = this.$el.find(this.classes.button);

  // vars
  this.dropdownOpen = false;

  // init
  this.init();
}

dropdown.prototype = {
  constructor: dropdown,

  classes: {
    dropdown: '.js-dropdown',
  },

  init: function(){
    this.addListener();
  },

  addListener: function(){
    this.$el.on('click', {self: this}, this.elClickHandler);
    $(document).on('click', {self: this}, this.documentClickHandler);
  },

  elClickHandler: function(event){
    var self = event.data.self;
    self.toggleDropdown(event);
  },

  documentClickHandler: function(event){
    var self = event.data.self;
    if(self.dropdownOpen){
      if( !$(event.target).closest(self.classes.dropdown).length ){
        self.toggleDropdown();
      }
    }
  },

  toggleDropdown: function(event){
    var self = this;
    event = event || false;
    if(self.dropdownOpen){
      self.$el.removeClass(app.names.isOpen);
      self.dropdownOpen = false;
    } else {
      if(event){
        event.preventDefault();
        event.stopPropagation();
      }
      self.$el.addClass(app.names.isOpen);
      self.dropdownOpen = true;
    }
  },
};

function validate($el) {
  this.$el = $el;

  this.$button = $el.find(this.classes.button);
  this.$success = $el.find(this.classes.success);
  this.$error = $el.find(this.classes.error);
  this.$captcha = $el.find(this.classes.captcha);
  this.$fileinput = $el.find(this.classes.fileinput);
  this.$deletefile = $el.find(this.classes.deletefile);

  // vars
  this.ajaxUrl = $el.attr('action');
  this.ajaxCall = undefined;

  this.init();
}

validate.prototype = {
  constructor: validate,

  settings: {

  },

  classes: {
    button: '.js-validate-button',
    success: '.js-validate-success',
    error: '.js-validate-error',
    captcha: '.js-validate-captcha',
    fileinput: '.js-fileinput',
    deletefile: '.js-fileinput-delete',
  },


  init: function() {
    this.initParsley();
    this.addListeners();
  },

  initParsley: function() {
    var self = this;
    self.$el.parsley();
  },

  addListeners: function() {
    this.$el.on('submit', {self: this}, this.formSubmitHandler);
    this.$fileinput.on('change', {self: this}, this.fileinputHandler);
    this.$deletefile.on('click', {self: this}, this.fileinputDeleteHandler);
  },

  fileinputDeleteHandler: function(event) {
    event.data.self.$fileinput.value = null;
    $(event.currentTarget).closest('.js-file-upload').removeClass('loaded');
    $('.js-file-upload').removeClass('error');
  },

  fileinputHandler: function(event) {
    if(event.currentTarget.files.length < 1){
      $(event.currentTarget).closest('.js-file-upload').removeClass('loaded');
    } else {
      $(event.currentTarget).closest('.js-file-upload').addClass('loaded');
      $(event.currentTarget).closest('.js-file-upload').find('.js-fileinput-filename').text(event.currentTarget.files[0].name);
    }
  },

  formSubmitHandler: function(event) {
    var self = event.data.self;
    event.preventDefault();

    var $preloaderContainer = self.$el;
    var preloaderType = '';
    self.$el.addClass(app.names.isLoading);
    if (self.$button.length) {
      $preloaderContainer = self.$button;
      preloaderType = 'small';
    }
    app.objects.preloader.showPreloader($preloaderContainer, '', preloaderType);

    if ($('input[name="company_name_hp"]').val() != '' ||  $('input[name="mobile_phone_hp"]').val() != '') {
      console.log('error');
    } else {
      // var formData = self.$el.serialize();
      var formData = new FormData(self.$el[0]);


      if (self.ajaxCall != undefined) {
        self.ajaxCall.abort();
      }

      // check if file is in there
      if(self.$fileinput.length > 0 && self.$fileinput[0].files.length > 0){
        $('.js-file-upload').removeClass('error');

        // check file type
        var allowedFileTypes = ['application/pdf', 'image/jpeg', 'image/png', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        if(!allowedFileTypes.includes(self.$fileinput[0].files[0].type)){
          self.$el.removeClass(app.names.isLoading);
          app.objects.preloader.hidePreloader($preloaderContainer);
          $('.js-file-upload').addClass('error');
          return;
        }
      }

      self.ajaxCall = $.ajax({
        url: self.ajaxUrl,
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false
      })
      .done(function(response) {
        response = $.parseJSON(response);
        if (response['status'] == 'success') {
          self.formActionDone(response);
        } else {
          self.formActionError(response);
        }

        // reset friendly recaptcha
        if(friendlyChallenge) {
          friendlyChallenge.autoWidget.reset();
        }
        
        self.$el.removeClass(app.names.isLoading);
        app.objects.preloader.hidePreloader($preloaderContainer);
      });
    }
  },

  formActionDone: function(response) {
    var self = this;
    self.$success.html(response['message']).velocity('fadeIn', {
      duration: app.settings.duration * 4,
    });
    setTimeout(function() {
      self.$success.velocity('fadeOut', {
        duration: app.settings.duration * 4,
      });
    }, 10000);
    self.$el[0].reset();

    self.$fileinput.value = null;
    $('.js-file-upload').removeClass('loaded');


    self.$error.velocity('fadeOut', {
      duration: app.settings.duration * 4,
    });
  },

  formActionError: function(response) {
    var self = this;
    self.$error.html(response['message']).velocity('fadeIn', {
      duration: app.settings.duration * 2,
    });
  },
};

function detectBrowser() {
  this.init();
}

detectBrowser.prototype = {

  dataBrowser: [
  {string: navigator.userAgent, subString: 'Edge', identity: 'edge'},
  {string: navigator.userAgent, subString: 'MSIE', identity: 'explorer'},
  {string: navigator.userAgent, subString: 'Trident', identity: 'explorer'},
  {string: navigator.userAgent, subString: 'Firefox', identity: 'firefox'},
  {string: navigator.userAgent, subString: 'Opera', identity: 'opera'},
  {string: navigator.userAgent, subString: 'OPR', identity: 'opera'},
  {string: navigator.userAgent, subString: 'Chrome', identity: 'chrome'},
  {string: navigator.userAgent, subString: 'Safari', identity: 'safari'},
  ],

  init: function() {
    app.vars.browser = this.searchString(this.dataBrowser) || 'other';
    app.vars.browserVersion = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || 'unknown';

    $('html').addClass(app.vars.browser).addClass(app.vars.browser + '-' + app.vars.browserVersion);
  },

  searchString: function(data) {
    for (var i = 0; i < data.length; i++) {
      var dataString = data[i].string;
      this.versionSearchString = data[i].subString;

      if (dataString.indexOf(data[i].subString) !== -1) {
        return data[i].identity;
      }
    }
  },
  searchVersion: function(dataString) {
    var index = dataString.indexOf(this.versionSearchString);
    if (index === -1) {
      return;
    }

    var rv = dataString.indexOf('rv:');
    if (this.versionSearchString === 'Trident' && rv !== -1) {
      return parseFloat(dataString.substring(rv + 3));
    } else {
      return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
    }
  },



};

function track() {}

track.prototype = {
  constructor: track,

  defaults: {
    category: 'General',
    action: 'Unnamed',
    label: '',
    value: '',
  },

  settings: {
    errorMsg: 'Event Tracking disabled: Google Analytics code not loaded',
  },

  classes: {
  },

  init: function(){
    this.addListener();
  },

  addListener: function(){
  },

  trackEvent: function(category, action, label){
    try {
      category = category || this.defaults.category;
      action = action || this.defaults.action;
      label = label || this.defaults.label;
      var value = app.vars.parameters['userId'];
      ga('send', 'event', category, action, label, value);
    } catch(err) {
      console.log(this.settings.errorMsg + '. Would\'ve tracked: ' + category + ', ' + action + ', ' + label + ', ' + value);
    }
  },

  trackPage: function(){
    try {
      ga('send', 'pageview', location.pathname);
    } catch(err) {
      console.log(this.settings.errorMsg + '. Would\'ve tracked: pageview, ' + location.pathname);
    }
  },


};

function videoPlayer($el) {
  this.$el = $el;
  this.$cover = $el.find(this.classes.cover);
  this.$container = $el.find(this.classes.container);
  this.$button = $el.find(this.classes.button);

  this.type = $el.data('type');
  this.source = $el.data('source');
  this.videoOn = false;

  this.init();
}

videoPlayer.prototype = {
  constructor: videoPlayer,

  settings: {
  },

  classes: {
    cover: '.js-video-player-cover',
    container: '.js-video-player-container',
    button: '.js-video-player-button',
  },

  init: function() {
    this.addListeners();
  },

  addListeners: function() {
    this.$cover.on('click', {self: this}, this.coverClickHandler);
  },

  coverClickHandler: function(event) {
    var self = event.data.self;
    self.openVideo();
  },

  openVideo: function() {
    if (this.videoOn) { return false; }
    this.videoOn = true;
    if (this.type === 'youtube') {
      this.loadYoutubeVideo();
    }
    this.showPlayer();
  },

  loadYoutubeVideo: function() {
    var template = '<iframe class="video-player__iframe"  width="640" height="360" src="https://www.youtube.com/embed/' + this.source + '?rel=0&amp;showinfo=0&amp;autoplay=1" frameborder="0" allowfullscreen></iframe>';
    this.$container.append(template);
  },

  showPlayer: function() {
    var self = this;
    this.$cover.addClass(app.names.isHidden);
    app.objects.preloader.showPreloader(this.$button);
    setTimeout(function() {
      self.$cover.remove();
    }, 2300);
  },


};

function mailLink($el) {
  this.$el = $el;

  var data = $el.data();

  this.user = data['user'];
  this.domain = data['domain'];
  this.text = data['text'];

  // init
  this.init();
}

mailLink.prototype = {
  constructor: mailLink, 

  init: function() {
    this.showLink();
  },
 
  showLink: function() {
    var mail = this.user + '@' + this.domain;
    var text = this.text;
    if (text == undefined) {
      text = mail;
    }
    this.$el.attr('href', 'mailto:' + mail);
    this.$el.text(text);

  },
};

function touchHover($el) {
  this.$el = $el;

  // vars
  this.touchHovered = false;

  this.init();
}

touchHover.prototype = {
  constructor: touchHover,

  init: function() {
    this.addListeners();
  }, 

  addListeners: function() {
    this.$el.on('click', {self: this}, this.elClickHandler);
    $(document).on('click', {self: this}, this.documentClickHandler);
  },

  elClickHandler: function(event) {
    var self = event.data.self;
    if (Modernizr.touchevents) { 
      event.preventDefault();
      if (self.touchHovered) {
        self.unhoverElement();
      } else {
        event.stopPropagation();
        self.hoverElement();
      }
    } 
  },

  documentClickHandler: function(event) {
    var self = event.data.self;
    if (self.touchHovered) {
      if (!$(event.target).closest(self.$el).length) {
        self.unhoverElement();
      }
    }
  },


  hoverElement: function() {
    this.touchHovered = true;
    this.$el.addClass(app.names.isHover);
  },

  unhoverElement: function() {
    this.touchHovered = false;
    this.$el.removeClass(app.names.isHover);
  },




};

function touchClass() {
  // vars
  this.init();
}

touchClass.prototype = {
  constructor: touchClass,

  init: function(){
    this.checkTouch();
  },

  checkTouch: function(){
    var deviceAgent = navigator.userAgent.toLowerCase();
    var touchEnabled = 'ontouchstart' in window || navigator.maxTouchPoints;

    if ((deviceAgent.match(/(iphone|ipod|ipad)/) ||
      deviceAgent.match(/(android)/)  ||
      deviceAgent.match(/(iemobile)/) ||
      deviceAgent.match(/iphone/i) ||
      deviceAgent.match(/ipad/i) ||
      deviceAgent.match(/ipod/i) ||
      deviceAgent.match(/blackberry/i) ||
      deviceAgent.match(/bada/i)) &&
      touchEnabled
      ) {

      if (document.body.className.indexOf('is-touchevents') !== -1)
        return

      if (document.body.className.length) {
        document.body.className += ' is-touchevents';
      } else{
        document.body.className = 'is-touchevents';
      }

    } else {
      if (document.body.className.indexOf('no-touchevents') !== -1)
        return

      if (document.body.className.length) {
        document.body.className += ' no-touchevents';
      } else{
        document.body.className = 'no-touchevents';
      }
    }
  },



};

function gaOptOut($el) {
  this.$el = $el;

  // init
  this.init();
}

gaOptOut.prototype = {
  constructor: gaOptOut, 

  settings: {
    cookieName: 'merzGaOptOut',
    cookieExpiration: 3650, //days
  },  

  classes: {
  },

  init: function(){
    this.addListener();
  },

  addListener: function(){
    this.$el.on('click', {self: this}, this.elClickHandler);
  },

  elClickHandler: function(event){
    var self = event.data.self;
    event.preventDefault();
    self.setGaOptOutCookie();
    self.showSuccess();
  },

  setGaOptOutCookie: function(){
    var self = this;
    Cookies.set(self.settings.cookieName, true, { expires: self.settings.cookieExpiration });
  },

  showSuccess: function(){
    this.$el.css('color', '#2ECC71');
    setTimeout(function(){
      location.reload();
    }, 1500);
  },
};

function nav($el) {
    this.$el = $el;

    this.$navLinks = $el.find(this.classes.navLink);
    this.$navLinksMobile = $el.find(this.classes.navLinkMobile);
    this.$navMenu = $el.find(this.classes.navMenu);
    this.$navSubmenus = $el.find(this.classes.navSubmenu);
    this.$navMobileMenu = $el.find(this.classes.navMobileMenu);

    //navs
    this.mouseOverArea = false;
    this.subMenuAnimated = false;
    this.menuOpen = false;

    this.init();
}


nav.prototype = {
    constructor: nav,
  
    classes: {
      nav: '.js-nav',
      navLink: '.js-nav__item',
      navLinkMobile: '.js-nav__item-mobile',
      navMenu: '.js-nav__menu',
      navSubmenu: '.js-nav__item-menu',
      navMobileMenu: '.js-nav-mobile__menu',
    },

    names: {
      isFixedHeader: 'is-fixed-header',
      notFixedHeader: 'not-fixed-header',
    },
  
    init: function() {
      this.addListeners();
    },
  
    addListeners: function() {
        var self = this;
        this.$navLinks.on('mouseenter', {self: this}, this.navLinksMouseEnterHandler);
        this.$navLinks.on('mouseleave', {self: this}, this.navLinksMouseLeaveHandler);
        this.$navMenu.on('click', {self: this}, this.navMenuClickHandler);
        this.$navLinksMobile.on('click', {self: this}, this.navLinksMobileClickHandler);
        // $(window).on('scroll', {self: this}, this.windowScrollHandler);

        document.addEventListener('closenav', function(event){ self.closenav(event, self) }, false);
    },

    closenav: function(event, self) {
      self.fixHeader(false);
      self.$navMobileMenu.slideUp(500, 'easeInOutExpo', function() {
        $(self.classes.nav).removeClass('is-open');
      });
    },

    navLinksMouseEnterHandler: function(event) {
      var self = event.data.self;
      self.mouseOverArea = true;
      $(this).addClass('is-active');
    },

    navLinksMouseLeaveHandler: function(event) {
      var self = event.data.self;
      self.mouseOverArea = false;
      $(this).removeClass('is-active');
    },

    navMenuClickHandler: function(event) {
      var self = event.data.self;
      var $mobileMenu = self.$navMobileMenu

      if(self.subMenuAnimated) {
        self.fixHeader(false);
        self.subMenuAnimated = false;
        $this =   $(self.classes.nav)
        $mobileMenu.slideUp(500, 'easeInOutExpo', function() {
          $this.removeClass('is-open');
        });
      } else {
        self.fixHeader(true);
        self.subMenuAnimated = true;
        $this =   $(self.classes.nav)
        $mobileMenu.slideDown(500, 'easeInOutExpo', function() {
          $this.addClass('is-open');
        });
      }
    },

    navLinksMobileClickHandler: function(event) {
      var wrap = $(event.target).closest('.navigation__sub-mobile__item');

      if(wrap.hasClass('is-active')) {
        wrap.find('.js-nav__item-menu').slideUp("slow", 'easeInOutExpo', function(){
          wrap.removeClass('is-active');
        });
      } else {
        wrap.find('.js-nav__item-menu').slideDown("slow", 'easeInOutExpo', function(){
          wrap.addClass('is-active');
        });
      }
    },

    fixHeader: function(fix) {
      if(fix){
        $('body').addClass('fixed');
        $('body').attr('data-scrollpos', window.scrollY);
      } else {
        $('body').removeClass('fixed');
        var scrollpos = $('body').attr('data-scrollpos');
        window.scrollTo(0, scrollpos);
      }
    },
  };


jQuery.easing['jswing'] = jQuery.easing['swing'];

jQuery.extend(jQuery.easing,
{
    def: 'easeOutQuad',
    swing: function (x, t, b, c, d) {
        //alert(jQuery.easing.default);
        return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
    },
    easeInOutExpo: function (x, t, b, c, d) {
        if (t==0) return b;
        if (t==d) return b+c;
        if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
        return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
    },
});
function inputDropdown($el) {
    this.$el = $el;
    this.$menu = $el.find(this.classes.menu);
    this.$search = $el.find(this.classes.search);
    this.$items = $el.find(this.classes.items);
    this.$checkbox = $el.find(this.classes.checkbox);
    this.$text= $el.find(this.classes.text)
    this.$clear= $(document).find(this.classes.clear)
    this.init();
  }
  
  inputDropdown.prototype = {
    constructor: inputDropdown,
  
    classes: {
     menu: '.js-input-dropdown__menu',
     search: '.js-input-dropdown__search',
     items: '.js-input-dropdown__item',
     checkbox: '.js-input-dropdown__checkbox',
     text: '.js-input-dropdown__text',
     clear: '.js-clear-filter'
    },
  
    names: {
      isDropdownOpen: false,
      isChecked: false,
      filterValues: [],
      allValues: [],
    },
  
    init: function() {
      this.addListeners();
    },
  
    addListeners: function() {
      this.$el.on('click', {self: this}, this.openDropodownMenuHandler);
      this.$search.on('input', {self: this}, this.searchHandler);
      this.$checkbox.on('change', {self: this}, this.checkboxHandler); 
      this.$clear.on('click', {self: this}, this.clearHandler); 
      $(document).on('click', {self: this}, this.hideDropdownMenuHandler);

      $(document).on('clearfilter', {self: this}, this.clearfilter);
    },


    openDropodownMenuHandler: function(event) {
      event.stopPropagation();
      var elem = event.target.closest('.js-input-dropdown');

      if(($(event.target).hasClass('input-dropdown__input-wrapper') || $(event.target).closest('.input-dropdown__input-wrapper').length > 0) && $(elem).hasClass('active')) {
        $(elem).removeClass('active');
      } else {
        $('.js-input-dropdown.active').each(function(){
          if($(this).attr('data-label') !== $(elem).attr('data-label')) {
            $(this).removeClass('active');
          }
        });
        if(!$(elem).hasClass('active')){
          $(elem).find('.js-input-dropdown__search').val('')
          $(event.data.self.$menu).children().show();
        }
        $(elem).addClass('active');
        $(elem).find('.js-input-dropdown__search').focus();
      }
    },

    hideDropdownMenuHandler: function(event) {      
      var elem = event.target.closest('.js-input-dropdown');

      if(elem === null){
        $(event.data.self.$el).removeClass('active');
        $(event.data.self.$menu).find('.noitem').remove();
      }
    },

    menuClickHandler: function(event) {
      event.stopPropagation();
    },

    filterDropdownItems: function(value) {
      var self = this;
      if(value.trim() == '') {
        this.$menu.children().show();
        $(self.$menu).find('.noitem').remove();
        return;
      }
      var self = this;
      this.$menu.children(':not(.noitem)').each(function() {
       if(!$(this).data('label').trim().toLowerCase().includes(value.trim().toLowerCase()) ) {
         $(this).hide();
        } {
          if($(self.$menu).find('.noitem').length < 1){
            $(self.$menu).append('<div class="noitem">' + self.$el.data('noresult') + '</div>');
          }
        }
      });

      if($(self.$menu).find('.input-dropdown__list__item:visible').length > 0){
        $(self.$menu).find('.noitem').remove();
      }
    },
    searchHandler: app.debounce(function(event) {
      event.stopPropagation();
      self = event.data.self;
      self.$menu.children().show();
      self.filterDropdownItems(event.target.value);
    }, 400),

    clearHandler: function(event) {
      $(document).trigger('clearfilter');
    },
    clearfilter: function(event) {
      var self = event.data.self;
      self.names.filterValues = [];

      self.$text.text(self.$el.data('label'))
      self.$menu.find('input[type="checkbox"]:checked').prop('checked', false);

      $(document).trigger('reloadproducts', [[]]);
    },

    checkboxHandler: function(event) {
      event.stopPropagation();
      var self = event.data.self;
      self.names.filterValues = []
      var $allInputs = self.$menu.find('input[type="checkbox"]:checked')

      $($allInputs).each(function(index, value) {
        self.names.filterValues.push(value.value)
      });

      if($allInputs.length) {
        self.$text.text(self.$el.data('selected') + ' (' + $allInputs.length + ')')
      } else {
        self.$text.text(self.$el.data('label'))
      }

      // fetch all data
      var allValues = []
      $('.js-input-dropdown').each(function() {
        var $allInputs = $(this).find('input[type="checkbox"]:checked')
        $($allInputs).each(function(index, value) {
          allValues.push(value.value + '=on')
        });
      });

      $(document).trigger('reloadproducts', [allValues]);
    }
  };

  
function productItem($el) {
    this.$el = $el;

    this.init();
  }
  
  productItem.prototype = {
    constructor: productItem,
  
    
    init: function() {
      this.addListener();
    },

    addListener: function() {
        this.$el.on('click', {self: this}, this.productItemClickHandler);
    },
    productItemClickHandler: function() {
        $(this).toggleClass(app.names.isActive)
    },
  
}

function initModules($context) {
  this.initGlobal();
  this.initLocal($context);
}

initModules.prototype = {
  constructor: initModules,

  initGlobal: function() {

    FastClick.attach(document.body);

    app.objects.header = new header($('.js-header'));
    app.objects.nav = new nav($('.js-nav'));

    app.objects.page = new page();

    app.objects.overlay = new overlay();

    app.objects.preloader = new preloader();
    
    app.objects.scrollToElement = new scrollToElement();

    app.objects.socialShare = new socialShare();

    app.objects.track = new track();

    app.objects.touchClass = new touchClass();

    new detectBrowser();

    new hoverTarget();

  },

  initLocal: function($context) {
	
	// if($context.find('.js-match-height').length > 0){
	// 	$context.find('.js-match-height').matchHeight({
	// 		byRow: true,
	// 		property: 'min-height',
	// 		target: null,
	// 		remove: false,
	// 	});
	// }

	// if($context.find('.js-match-height-2').length > 0){
    // 	$context.find('.js-match-height-2').matchHeight();
	// }

    if (app.objects.sticky === undefined) {
      app.objects.sticky = [];
    }
    $context.find('.js-sticky').each(function(index) {
      app.objects.sticky.push(new sticky($(this)));
    });

    $context.find('.js-dropdown').each(function() {
      app.objects.dropdown = new dropdown($(this));
    });

    $context.find('.js-lightbox').each(function() {
      new lightbox($(this));
    });

    $context.find('.js-carousel').each(function() {
      new carousel($(this));
    });
    
    $context.find('.js-slider').each(function() {
      new slider($(this));
    });
    
    $context.find('.js-products').each(function() {
      new products($(this));
    });
    
    $context.find('.js-tabs').each(function() {
      new tabs($(this));
    });
    
    $context.find('.js-presentation').each(function() {
      new presentation($(this));
    });
    
    $context.find('.js-faq').each(function() {
      new faq($(this));
    });
    
    $context.find('.js-overview').each(function() {
      app.objects.overview = new overview($(this));
    });
    
    $context.find('.js-scroll-nav').each(function() {
      app.objects.scrollNav = new scrollNav($(this));
    });
    
    $context.find('.js-gallery').each(function() {
      new gallery($(this));
    });
    
    $context.find('.js-search').each(function() {
      new search($(this));
    });
    
    $context.find('.js-cookie').each(function() {
      new cookie($(this));
    });

    $context.find('.js-timeline').each(function() {
      app.objects.timeline = new timeline($(this));
    });
    
    $context.find('.js-toggle-btn').each(function() {
      new toggleElement($(this));
    });
    
    $context.find('.js-featured').each(function() {
      app.objects.featured = new featured($(this));
    });

    $context.find('.js-validate').each(function() {
      new validate($(this));
    });

    $context.find('.js-video-player').each(function() {
      new videoPlayer($(this));
    });

    $context.find('.js-mail-link').each(function() {
      new mailLink($(this));
    });

    $context.find('.js-touch-hover').each(function() {
      new touchHover($(this));
    });

    $context.find('a[href="#google-opt-out"]').each(function() {
      new gaOptOut($(this));
    });

    $context.find('.js-baby-product-item').each(function() {
      new productItem($(this));
    });

    $context.find('.js-input-dropdown').each(function() {
      new inputDropdown($(this));
    });

  },

};


}(jQuery));
